/* =========================================
   PRODUCT COPY
========================================= */
export const productCopy = {
    "Afnan 9 AM Eau de Parfum": {
    miniTag: { sr: "🍊 Citrusni / Čist", en: "🍊 Citrus / Clean" },
    card: {
      sr: "Vedri citrusi i kardamom u čistom, energičnom dnevnom mirisu.",
      en: "Bright citrus and cardamom in a clean, energetic daytime scent.",
    },
    modal: {
      sr: "Mandarina i citron otvaraju miris sveže i vedro, dok lavanda, cvet narandže i suvo drvo daju uredan aromatičan karakter.",
      en: "Mandarin and cedrat open with bright freshness, while lavender, orange blossom and dry woods create a polished aromatic character.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["mandarina", "citron", "lavanda", "kedar"],
      en: ["mandarin", "cedrat", "lavender", "cedarwood"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Svakodnevni"],
      en: ["Fresh", "Summer", "Daily"],
    },
    whyChoose: {
      sr: "Ako želiš nenametljiv, uredan i energičan parfem za tople dane.",
      en: "If you want an effortless, polished and energetic fragrance for warm days.",
    },
  },

  "Afnan 9 PM Rebel Eau de Parfum": {
    miniTag: { sr: "🍍 Voćni / Večernji", en: "🍍 Fruity / Night" },
    card: {
      sr: "Sočni ananas i zelena jabuka prelaze u vanilu i karamelizovano drvo.",
      en: "Juicy pineapple and green apple melt into vanilla and caramelized woods.",
    },
    modal: {
      sr: "Voćni početak donosi ananas, mandarinu i zelenu jabuku, a vanila, karamela i suvo drvo grade sladak, moderan i upečatljiv trag.",
      en: "Pineapple, mandarin and green apple lead into vanilla, caramel and dry woods, creating a sweet, modern and attention-grabbing trail.",
    },
    scentType: {
      sr: "Voćni, drvenast i ambrast",
      en: "Fruity woody amber",
    },
    dominantNotes: {
      sr: ["ananas", "zelena jabuka", "vanila", "karamela"],
      en: ["pineapple", "green apple", "vanilla", "caramel"],
    },
    tags: {
      sr: ["Sladak", "Večernji", "Prepoznatljiv"],
      en: ["Sweet", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš moderan voćno-sladak parfem koji lako privlači pažnju.",
      en: "If you want a modern fruity-sweet fragrance that easily draws attention.",
    },
  },

  "Afnan Supremacy Collector's Edition Pour Homme Eau de Parfum": {
    miniTag: { sr: "🍍 Voćni / Snažan", en: "🍍 Fruity / Bold" },
    card: {
      sr: "Ananas, bergamot i breza u bogatom voćno-drvenastom profilu.",
      en: "Pineapple, bergamot and birch in a rich fruity-woody profile.",
    },
    modal: {
      sr: "Sočan spoj ananasa, bergamota i jabuke prelazi u brezu, amber i hrastovu mahovinu, ostavljajući snažan i elegantan trag.",
      en: "A juicy blend of pineapple, bergamot and apple develops into birch, amber and oakmoss, leaving a bold and elegant trail.",
    },
    scentType: {
      sr: "Voćni, drvenast i mahovinast",
      en: "Fruity woody mossy",
    },
    dominantNotes: {
      sr: ["ananas", "bergamot", "breza", "hrastova mahovina"],
      en: ["pineapple", "bergamot", "birch", "oakmoss"],
    },
    tags: {
      sr: ["Snažan", "Prepoznatljiv", "Svestran"],
      en: ["Bold", "Signature", "Versatile"],
    },
    whyChoose: {
      sr: "Ako voliš moćne voćno-drvenaste mirise sa ozbiljnim i luksuznim utiskom.",
      en: "If you enjoy powerful fruity-woody scents with a refined, luxurious presence.",
    },
  },

  "Afnan Turathi Blue Homme Eau de Parfum": {
    miniTag: { sr: "🍋 Citrusni / Drvenast", en: "🍋 Citrus / Woody" },
    card: {
      sr: "Bergamot i mandarina iznad čiste, ambrasto-drvenaste baze.",
      en: "Bergamot and mandarin over a clean amber-woody base.",
    },
    modal: {
      sr: "Svetli citrusi otvaraju miris energično, dok amber, mošus, pačuli i sveži začini donose uglađen i prepoznatljiv završetak.",
      en: "Bright citrus opens with energy, while amber, musk, patchouli and fresh spices create a polished, distinctive finish.",
    },
    scentType: {
      sr: "Citrusni, ambrast i drvenast",
      en: "Citrus amber woody",
    },
    dominantNotes: {
      sr: ["bergamot", "mandarina", "amber", "mošus"],
      en: ["bergamot", "mandarin", "amber", "musk"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Prepoznatljiv"],
      en: ["Fresh", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš luksuznu citrusnu svežinu sa dovoljno karaktera i postojanosti.",
      en: "If you want luxurious citrus freshness with character and lasting presence.",
    },
  },

  "Arabiyat Prestige Marwa Eau de Parfum": {
    miniTag: { sr: "🍵 Citrusni / Čajni", en: "🍵 Citrus / Tea" },
    card: {
      sr: "Bergamot, đumbir i crni čaj u čistom, modernom spoju.",
      en: "Bergamot, ginger and black tea in a clean, modern blend.",
    },
    modal: {
      sr: "Bergamot i đumbir donose blistav početak, dok crni čaj, tamjan, ambroksan i gvajak grade elegantan i prozračan drvenasti trag.",
      en: "Bergamot and ginger create a radiant opening, while black tea, incense, ambroxan and guaiac wood form an elegant, airy woody trail.",
    },
    scentType: {
      sr: "Citrusni, čajni i drvenast",
      en: "Citrus tea woody",
    },
    dominantNotes: {
      sr: ["bergamot", "đumbir", "crni čaj", "ambroksan"],
      en: ["bergamot", "ginger", "black tea", "ambroxan"],
    },
    tags: {
      sr: ["Svež", "Čist", "Prepoznatljiv"],
      en: ["Fresh", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš čist, luksuzan i veoma nosiv parfem za tople dane.",
      en: "If you want a clean, luxurious and highly wearable fragrance for warm days.",
    },
  },

  "Armaf Club de Nuit Bling Eau de Parfum": {
    miniTag: { sr: "✨ Cvetni / Sladak", en: "✨ Floral / Sweet" },
    card: {
      sr: "Svetlucavi citrusi, cvetni akordi i meka vanila u razigranom spoju.",
      en: "Sparkling citrus, floral accords and soft vanilla in a playful blend.",
    },
    modal: {
      sr: "Vedri citrusi prelaze u blistavo cvetno srce, dok vanila i baršunasto drvo daju topao, zavodljiv i moderan završetak.",
      en: "Bright citrus moves into a luminous floral heart, while vanilla and velvety woods create a warm, seductive and modern finish.",
    },
    scentType: {
      sr: "Citrusni, cvetni i vanilast",
      en: "Citrus floral vanilla",
    },
    dominantNotes: {
      sr: ["citrusi", "cvetni akordi", "vanila", "baršunasto drvo"],
      en: ["citrus", "floral accords", "vanilla", "velvety woods"],
    },
    tags: {
      sr: ["Sladak", "Cvetni", "Večernji"],
      en: ["Sweet", "Floral", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš razigran i upečatljiv miris sa slatkim, glamuroznim karakterom.",
      en: "If you want a playful statement scent with a sweet, glamorous character.",
    },
  },

  "Armaf Club de Nuit Intense Man Eau de Toilette": {
    miniTag: { sr: "🍋 Dimni / Snažan", en: "🍋 Smoky / Bold" },
    card: {
      sr: "Oštar citrusni početak sa tamnom brezom i snažnom drvenastom bazom.",
      en: "A sharp citrus opening with dark birch and a powerful woody base.",
    },
    modal: {
      sr: "Limun, ananas i bergamot otvaraju miris intenzivno, dok breza, mošus, ambergris i pačuli grade prepoznatljiv dimno-drvenasti trag.",
      en: "Lemon, pineapple and bergamot open with intensity, while birch, musk, ambergris and patchouli build its signature smoky-woody trail.",
    },
    scentType: {
      sr: "Citrusni, dimni i drvenast",
      en: "Citrus smoky woody",
    },
    dominantNotes: {
      sr: ["limun", "ananas", "breza", "ambergris"],
      en: ["lemon", "pineapple", "birch", "ambergris"],
    },
    tags: {
      sr: ["Snažan", "Prepoznatljiv", "Svestran"],
      en: ["Bold", "Signature", "Versatile"],
    },
    whyChoose: {
      sr: "Ako želiš snažan prvi utisak i miris koji ostaje prepoznatljiv tokom dana.",
      en: "If you want a strong first impression and a scent that stays distinctive throughout the day.",
    },
  },

  "Armaf Club de Nuit Sillage Eau de Parfum": {
    miniTag: { sr: "🧊 Mineralni / Svež", en: "🧊 Mineral / Fresh" },
    card: {
      sr: "Hladni citrusi, iris i mošus u čistom mineralnom profilu.",
      en: "Icy citrus, iris and musk in a clean mineral profile.",
    },
    modal: {
      sr: "Bergamot, limun i limeta daju oštar, blistav početak, a iris, ruža, sandalovina i mošus stvaraju hladan i elegantan trag.",
      en: "Bergamot, lemon and lime create a sharp, luminous opening, while iris, rose, sandalwood and musk leave a cool, elegant trail.",
    },
    scentType: {
      sr: "Citrusni, cvetni i mošusni",
      en: "Citrus floral musky",
    },
    dominantNotes: {
      sr: ["bergamot", "limun", "iris", "mošus"],
      en: ["bergamot", "lemon", "iris", "musk"],
    },
    tags: {
      sr: ["Svež", "Čist", "Letnji"],
      en: ["Fresh", "Clean", "Summer"],
    },
    whyChoose: {
      sr: "Ako voliš hladnu, mineralnu svežinu koja se razlikuje od klasičnih plavih parfema.",
      en: "If you enjoy cool mineral freshness that stands apart from typical blue fragrances.",
    },
  },

  "French Avenue Vulcan Sable Eau de Parfum": {
    miniTag: { sr: "🥃 Začinski / Topao", en: "🥃 Spicy / Warm" },
    card: {
      sr: "Viskij i korijander preko tople, kremaste sandalovine.",
      en: "Whiskey, coriander and creamy sandalwood in a rich evening scent.",
    },
    modal: {
      sr: "Topao viski i začinski korijander prelaze u sandalovinu i kašmeran, dok tonka, benzoin i vanila grade gust i zavodljiv završetak.",
      en: "Warm whiskey and spicy coriander develop into sandalwood and cashmeran, while tonka, benzoin and vanilla create a dense, seductive finish.",
    },
    scentType: {
      sr: "Začinski, drvenast i gurmanski",
      en: "Spicy woody gourmand",
    },
    dominantNotes: {
      sr: ["viski", "korijander", "sandalovina", "vanila"],
      en: ["whiskey", "coriander", "sandalwood", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Gurmanski"],
      en: ["Rich", "Night", "Gourmand"],
    },
    whyChoose: {
      sr: "Ako želiš topao, luksuzan i zavodljiv parfem za hladnije večeri.",
      en: "If you want a warm, luxurious and seductive fragrance for cooler evenings.",
    },
  },

  "Haramain Signature Blue Eau de Parfum": {
    miniTag: { sr: "🔵 Citrusni / Aromatičan", en: "🔵 Citrus / Aromatic" },
    card: {
      sr: "Limun, bergamot i grejp u čistom aromatično-drvenastom profilu.",
      en: "Lemon, bergamot and grapefruit in a clean aromatic-woody profile.",
    },
    modal: {
      sr: "Svetli citrusi i aromatični geranijum prelaze u kedar, vetiver i pačuli, stvarajući uredan i svestran svakodnevni miris.",
      en: "Bright citrus and aromatic geranium settle into cedarwood, vetiver and patchouli, creating a polished and versatile everyday scent.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["limun", "grejp", "geranijum", "kedar"],
      en: ["lemon", "grapefruit", "geranium", "cedarwood"],
    },
    tags: {
      sr: ["Svež", "Svakodnevni", "Letnji"],
      en: ["Fresh", "Daily", "Summer"],
    },
    whyChoose: {
      sr: "Ako želiš čist i pouzdan parfem za posao, dnevne obaveze i toplo vreme.",
      en: "If you want a clean, dependable fragrance for work, daily wear and warm weather.",
    },
  },

    "Khadlaj Island Dreams Extrait de Parfum": {
    miniTag: { sr: "🍊 Citrusni / Blistav", en: "🍊 Citrus / Radiant" },
    card: {
      sr: "Grejp, bergamot i đumbir u blistavom, modernom letnjem mirisu.",
      en: "Grapefruit, bergamot and ginger in a radiant modern summer scent.",
    },
    modal: {
      sr: "Bergamot i đumbir otvaraju miris živahno, sočni grejp ostaje u centru, a ambroksan i mošus daju čist, elegantan i dugotrajan trag.",
      en: "Bergamot and ginger create a lively opening, juicy grapefruit stays at the center, and ambroxan with musk leaves a clean, elegant and lasting trail.",
    },
    scentType: {
      sr: "Citrusni, mošusni i ambrast",
      en: "Citrus musky amber",
    },
    dominantNotes: {
      sr: ["grejp", "bergamot", "đumbir", "ambroksan"],
      en: ["grapefruit", "bergamot", "ginger", "ambroxan"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Prepoznatljiv"],
      en: ["Fresh", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš vedar i luksuzan citrusni miris koji ostaje čist i moderan.",
      en: "If you want a bright, luxurious citrus fragrance that stays clean and modern.",
    },
  },

  "Lattafa Asad Elixir Eau de Parfum": {
    miniTag: { sr: "🚬 Duvanski / Začinski", en: "🚬 Tobacco / Spicy" },
    card: {
      sr: "Šafran, duvan i vanila u dubokom začinsko-drvenastom spoju.",
      en: "Saffron, tobacco and vanilla in a deep spicy-woody blend.",
    },
    modal: {
      sr: "Ružičasti biber, šafran i grejp otvaraju miris intenzivno, dok duvan, kedar, vanila i tamjan grade taman, topao i autoritativan trag.",
      en: "Pink pepper, saffron and grapefruit open with intensity, while tobacco, cedarwood, vanilla and olibanum build a dark, warm and commanding trail.",
    },
    scentType: {
      sr: "Začinski, duvanski i drvenast",
      en: "Spicy tobacco woody",
    },
    dominantNotes: {
      sr: ["šafran", "duvan", "vanila", "tamjan"],
      en: ["saffron", "tobacco", "vanilla", "olibanum"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš snažan, ozbiljan i zavodljiv parfem za hladnije večeri.",
      en: "If you want a powerful, serious and seductive fragrance for cooler evenings.",
    },
  },

  "Lattafa Fakhar Black Eau de Parfum": {
    miniTag: { sr: "🍏 Aromatičan / Svež", en: "🍏 Aromatic / Fresh" },
    card: {
      sr: "Jabuka, đumbir i lavanda u čistom, modernom aromatičnom profilu.",
      en: "Apple, ginger and lavender in a clean modern aromatic profile.",
    },
    modal: {
      sr: "Hrskava jabuka, bergamot i đumbir prelaze u lavandu, žalfiju i kleku, dok tonka, kedar i amber drvo daju gladak i svestran završetak.",
      en: "Crisp apple, bergamot and ginger develop into lavender, sage and juniper, while tonka, cedarwood and amberwood create a smooth, versatile finish.",
    },
    scentType: {
      sr: "Voćni, aromatičan i drvenast",
      en: "Fruity aromatic woody",
    },
    dominantNotes: {
      sr: ["jabuka", "đumbir", "lavanda", "amber drvo"],
      en: ["apple", "ginger", "lavender", "amberwood"],
    },
    tags: {
      sr: ["Čist", "Svestran", "Prepoznatljiv"],
      en: ["Clean", "Versatile", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš moderan i siguran izbor koji radi od dnevnih obaveza do večernjeg izlaska.",
      en: "If you want a modern, dependable choice that works from daily wear to an evening out.",
    },
  },

  "Lattafa Khamrah Qahwa Eau de Parfum": {
    miniTag: { sr: "☕ Kafa / Gurmanski", en: "☕ Coffee / Gourmand" },
    card: {
      sr: "Arapska kafa, praline i topli začini u bogatom gurmanskom mirisu.",
      en: "Arabica coffee, praline and warm spices in a rich gourmand scent.",
    },
    modal: {
      sr: "Đumbir, cimet i kardamom otvaraju miris toplinom, praline i kandirano voće donose slatkoću, a arapska kafa, tonka i mošus ostavljaju gust i zavodljiv trag.",
      en: "Ginger, cinnamon and cardamom open with warmth, praline and candied fruits add sweetness, while Arabica coffee, tonka and musk leave a dense, seductive trail.",
    },
    scentType: {
      sr: "Začinski, kafeni i gurmanski",
      en: "Spicy coffee gourmand",
    },
    dominantNotes: {
      sr: ["arapska kafa", "cimet", "praline", "tonka"],
      en: ["Arabica coffee", "cinnamon", "praline", "tonka bean"],
    },
    tags: {
      sr: ["Sladak", "Bogat", "Večernji"],
      en: ["Sweet", "Rich", "Night"],
    },
    whyChoose: {
      sr: "Ako voliš raskošne gurmanske parfeme u kojima kafa zaista ima glavnu ulogu.",
      en: "If you enjoy opulent gourmand fragrances where coffee truly takes center stage.",
    },
  },

  "Lattafa Musamam Black Intense Eau de Parfum": {
    miniTag: { sr: "🌑 Začinski / Drvenast", en: "🌑 Spicy / Woody" },
    card: {
      sr: "Lavanda, muškatni oraščić i tamno drvo u modernom intenzivnom spoju.",
      en: "Lavender, nutmeg and dark woods in a modern intense blend.",
    },
    modal: {
      sr: "Lavanda, muškatni oraščić i bergamot vode u aromatično cvetno srce, dok javorovo drvo, kakao akord i Ambrofix daju taman, gladak i savremen trag.",
      en: "Lavender, nutmeg and bergamot lead into an aromatic floral heart, while maple wood, a cocoa accord and Ambrofix create a dark, smooth and contemporary trail.",
    },
    scentType: {
      sr: "Aromatičan, začinski i drvenast",
      en: "Aromatic spicy woody",
    },
    dominantNotes: {
      sr: ["lavanda", "muškatni oraščić", "javorovo drvo", "kakao akord"],
      en: ["lavender", "nutmeg", "maple wood", "cocoa accord"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš taman i sofisticiran miris bez klasične oud težine.",
      en: "If you want a dark, sophisticated scent without the usual heaviness of oud.",
    },
  },

  "Lattafa Qaed Al Fursan Untamed Eau de Parfum": {
    miniTag: { sr: "🔥 Začinski / Ambrast", en: "🔥 Spicy / Amber" },
    card: {
      sr: "Kardamom, karamela i smolasto drvo u toplom, upečatljivom mirisu.",
      en: "Cardamom, caramel and resinous woods in a warm statement scent.",
    },
    modal: {
      sr: "Muškatni oraščić, kardamom i mandarina prelaze u lavandu, žalfiju i karamelu, dok kedar, tamjan i labdanum grade topao smolasti završetak.",
      en: "Nutmeg, cardamom and mandarin develop into lavender, clary sage and caramel, while cedarwood, olibanum and labdanum create a warm resinous finish.",
    },
    scentType: {
      sr: "Začinski, karamelni i smolast",
      en: "Spicy caramel resinous",
    },
    dominantNotes: {
      sr: ["kardamom", "karamela", "tamjan", "labdanum"],
      en: ["cardamom", "caramel", "olibanum", "labdanum"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš neobičan spoj toplih začina, karamele i tamnih smola.",
      en: "If you want an unusual blend of warm spices, caramel and dark resins.",
    },
  },

  "Paris Corner Emir Trillium Eau de Parfum": {
    miniTag: { sr: "🍊 Citrusni / Vetiverski", en: "🍊 Citrus / Vetiver" },
    card: {
      sr: "Grejp, bergamot i vetiver u živahnom, elegantnom letnjem mirisu.",
      en: "Grapefruit, bergamot and vetiver in a vibrant elegant summer scent.",
    },
    modal: {
      sr: "Grejp i bergamot blistaju uz aromatičnu majčinu dušicu, dok vetiver, kleka, crna ribizla i ambergris daju čist ali karakteran završetak.",
      en: "Grapefruit and bergamot shine beside aromatic thyme, while vetiver, juniper, black currant and ambergris create a clean yet distinctive finish.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["grejp", "bergamot", "vetiver", "kleka"],
      en: ["grapefruit", "bergamot", "vetiver", "juniper"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Prepoznatljiv"],
      en: ["Fresh", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš ozbiljniju citrusnu svežinu sa vetiverom i elegantnom dubinom.",
      en: "If you want refined citrus freshness with vetiver and elegant depth.",
    },
  },

  "Paris Corner Emir Voux Elegante Eau de Parfum": {
    miniTag: { sr: "🍯 Medni / Duvanski", en: "🍯 Honey / Tobacco" },
    card: {
      sr: "Lavanda, med i duvan u toplom, raskošnom večernjem mirisu.",
      en: "Lavender, honey and tobacco in a warm opulent evening scent.",
    },
    modal: {
      sr: "Aromatična lavanda i bergamot vode u bogato srce od meda, cimeta i kašmerana, dok duvan, tonka i vanila ostavljaju mekan i zavodljiv trag.",
      en: "Aromatic lavender and bergamot lead into a rich heart of honey, cinnamon and cashmeran, while tobacco, tonka and vanilla leave a smooth, seductive trail.",
    },
    scentType: {
      sr: "Aromatičan, medni i duvanski",
      en: "Aromatic honey tobacco",
    },
    dominantNotes: {
      sr: ["lavanda", "med", "duvan", "vanila"],
      en: ["lavender", "honey", "tobacco", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako voliš raskošne medno-duvanske parfeme sa slatkom, elegantnom toplinom.",
      en: "If you enjoy opulent honey-tobacco fragrances with sweet, elegant warmth.",
    },
  },

  "Paris Corner Ministry of Oud Oud Satin Extrait de Parfum": {
    miniTag: { sr: "🌹 Ruža / Oud", en: "🌹 Rose / Oud" },
    card: {
      sr: "Oud, ruža i vanila u raskošnom, baršunastom spoju.",
      en: "Oud, rose and vanilla in an opulent velvety blend.",
    },
    modal: {
      sr: "Duboki oud i raskošna ruža susreću se sa toplim benzoinom, puderastom ljubičicom i vanilom, stvarajući gust i senzualan trag.",
      en: "Deep oud and opulent rose meet warm benzoin, powdery violet and vanilla, creating a dense and sensual trail.",
    },
    scentType: {
      sr: "Cvetni, oud i vanilast",
      en: "Floral oud vanilla",
    },
    dominantNotes: {
      sr: ["oud", "ruža", "benzoin", "vanila"],
      en: ["oud", "rose", "benzoin", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Mekan", "Večernji"],
      en: ["Rich", "Soft", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš raskošan spoj ouda i ruže sa mekanom, puderasto-slatkom bazom.",
      en: "If you want an opulent oud-and-rose blend with a soft powdery-sweet base.",
    },
  },

  "Paris Corner North Stag Expressions II Deux Extrait de Parfum": {
    miniTag: { sr: "🍏 Aromatičan / Začinski", en: "🍏 Aromatic / Spicy" },
    card: {
      sr: "Jabuka, lavanda i kardamom u toplom, elegantnom večernjem mirisu.",
      en: "Apple, lavender and cardamom in a warm elegant evening scent.",
    },
    modal: {
      sr: "Jabuka, lavanda i bergamot otvaraju miris sveže, a geranijum, ljubičica, kardamom, sandalovina i vanila razvijaju njegov topao i zavodljiv karakter.",
      en: "Apple, lavender and bergamot open with freshness, while geranium, violet, cardamom, sandalwood and vanilla develop its warm, seductive character.",
    },
    scentType: {
      sr: "Voćni, aromatičan i začinski",
      en: "Fruity aromatic spicy",
    },
    dominantNotes: {
      sr: ["jabuka", "lavanda", "kardamom", "vanila"],
      en: ["apple", "lavender", "cardamom", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš svestran, elegantan i zavodljiv parfem za hladnije dane i večeri.",
      en: "If you want a versatile, elegant and seductive fragrance for cooler days and evenings.",
    },
  },

    "Rayhaan Aquatica Eau de Parfum": {
    miniTag: { sr: "🥥 Tropski / Svež", en: "🥥 Tropical / Fresh" },
    card: {
      sr: "Kokos, limeta i beli rum u vedrom tropskom letnjem mirisu.",
      en: "Coconut, lime and white rum in a bright tropical summer scent.",
    },
    modal: {
      sr: "Kokos, limeta i bergamot otvaraju miris sočno, đumbir i egzotično cveće daju mu živost, a beli rum, šećerna trska i mošus zaokružuju tropski karakter.",
      en: "Coconut, lime and bergamot open with juicy freshness, ginger and exotic florals add vibrancy, while white rum, sugar cane and musk complete its tropical character.",
    },
    scentType: {
      sr: "Tropski, citrusni i mošusni",
      en: "Tropical citrus musky",
    },
    dominantNotes: {
      sr: ["kokos", "limeta", "beli rum", "šećerna trska"],
      en: ["coconut", "lime", "white rum", "sugar cane"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Mekan"],
      en: ["Fresh", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš opušten tropski miris koji spaja citrusnu svežinu i blagu slatkoću.",
      en: "If you want a relaxed tropical fragrance blending citrus freshness with gentle sweetness.",
    },
  },

  "Rayhaan Pacific Aura Eau de Parfum": {
    miniTag: { sr: "🌿 Voćni / Zeleni", en: "🌿 Fruity / Green" },
    card: {
      sr: "Citron, nana i kajsija u zelenom, osvežavajućem letnjem spoju.",
      en: "Citron, mint and apricot in a green refreshing summer blend.",
    },
    modal: {
      sr: "Citron, limun, narandža i nana daju blistav početak, kajsija, bosiljak i ruža unose voćno-zelenu mekoću, a smokva, urme i ambreta zaokružuju miris.",
      en: "Citron, lemon, orange and mint create a radiant opening, apricot, basil and rose add fruity-green softness, while fig, dates and ambrette round out the scent.",
    },
    scentType: {
      sr: "Citrusni, voćni i zeleni",
      en: "Citrus fruity green",
    },
    dominantNotes: {
      sr: ["citron", "nana", "kajsija", "smokva"],
      en: ["citron", "mint", "apricot", "fig"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Mekan"],
      en: ["Fresh", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako voliš prirodnu, voćno-zelenu svežinu koja deluje vedro i nenametljivo.",
      en: "If you enjoy natural fruity-green freshness that feels bright and effortless.",
    },
  },

  "Swiss Arabian Tobacco 01 Extrait de Parfum": {
    miniTag: { sr: "🚬 Duvan / Med", en: "🚬 Tobacco / Honey" },
    card: {
      sr: "Šljiva, med i duvan u raskošnom začinsko-ambrastom mirisu.",
      en: "Plum, honey and tobacco in an opulent spicy-amber fragrance.",
    },
    modal: {
      sr: "Šljiva, jabuka i ružičasti biber vode u bogato srce od labdanuma, ambera i pačulija, dok duvan, med, vanila i sandalovina ostavljaju gust i luksuzan trag.",
      en: "Plum, apple and pink pepper lead into a rich heart of labdanum, amber and patchouli, while tobacco, honey, vanilla and sandalwood leave a dense luxurious trail.",
    },
    scentType: {
      sr: "Voćni, ambrast i duvanski",
      en: "Fruity amber tobacco",
    },
    dominantNotes: {
      sr: ["šljiva", "duvan", "med", "vanila"],
      en: ["plum", "tobacco", "honey", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš ozbiljan duvanski parfem sa voćnom slatkoćom i raskošnom dubinom.",
      en: "If you want a serious tobacco fragrance with fruity sweetness and opulent depth.",
    },
  },

  "Acqua di Parma Blu Mediterraneo Fico di Amalfi Eau de Toilette": {
    miniTag: { sr: "🌿 Smokva / Citrusni", en: "🌿 Fig / Citrus" },
    card: {
      sr: "Sočna smokva i italijanski citrusi u mediteranski vedrom mirisu.",
      en: "Juicy fig and Italian citrus in a bright Mediterranean scent.",
    },
    modal: {
      sr: "Italijanski limun, bergamot i grejp otvaraju miris blistavo, nektar smokve i jasmin donose mekoću, a drvo smokve, kedar i benzoin toplinu.",
      en: "Italian lemon, bergamot and grapefruit create a radiant opening, fig nectar and jasmine add softness, while fig wood, cedarwood and benzoin bring warmth.",
    },
    scentType: {
      sr: "Citrusni, voćni i drvenast",
      en: "Citrus fruity woody",
    },
    dominantNotes: {
      sr: ["italijanski limun", "nektar smokve", "drvo smokve", "kedar"],
      en: ["Italian lemon", "fig nectar", "fig wood", "cedarwood"],
    },
    tags: {
      sr: ["Svež", "Letnji", "Mekan"],
      en: ["Fresh", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš prirodan, elegantan i bezbrižan miris mediteranskog ljeta.",
      en: "If you want a natural, elegant and carefree scent of a Mediterranean summer.",
    },
  },

  "Acqua di Parma Colonia Essenza Eau de Cologne": {
    miniTag: { sr: "🍋 Citrusni / Klasičan", en: "🍋 Citrus / Classic" },
    card: {
      sr: "Neroli, limun i vetiver u preciznoj italijanskoj kolonjskoj eleganciji.",
      en: "Neroli, lemon and vetiver in precise Italian cologne elegance.",
    },
    modal: {
      sr: "Bogat spoj limuna, narandže, bergamota i nerolija prelazi u aromatično-cvetno srce, dok vetiver, pačuli, beli mošus i amber daju profinjen završetak.",
      en: "A rich blend of lemon, orange, bergamot and neroli develops into an aromatic floral heart, while vetiver, patchouli, white musk and amber create a refined finish.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i mošusni",
      en: "Citrus aromatic musky",
    },
    dominantNotes: {
      sr: ["neroli", "limun", "ruzmarin", "vetiver"],
      en: ["neroli", "lemon", "rosemary", "vetiver"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako tražiš besprekoran, klasičan i luksuzan citrusni miris za toplo vreme.",
      en: "If you seek an impeccable, classic and luxurious citrus fragrance for warm weather.",
    },
  },

  "Acqua di Parma Colonia Pura Eau de Cologne": {
    miniTag: { sr: "🍊 Citrusni / Mošusni", en: "🍊 Citrus / Musky" },
    card: {
      sr: "Italijanski citrusi, jasmin i mošus u čistom, modernom spoju.",
      en: "Italian citrus, jasmine and musk in a clean modern blend.",
    },
    modal: {
      sr: "Bergamot, narandža i petitgrain otvaraju miris svetlo, korijander, jasmin sambak i narcis daju karakter, a kedar, pačuli i mošus mekanu dubinu.",
      en: "Bergamot, orange and petitgrain open brightly, coriander, jasmine sambac and narcissus add character, while cedarwood, patchouli and musk bring soft depth.",
    },
    scentType: {
      sr: "Citrusni, cvetni i mošusni",
      en: "Citrus floral musky",
    },
    dominantNotes: {
      sr: ["bergamot", "italijanska narandža", "jasmin sambak", "mošus"],
      en: ["bergamot", "Italian orange", "jasmine sambac", "musk"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Mekan"],
      en: ["Clean", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš savremenu italijansku kolonjsku svežinu sa mekim i elegantnim tragom.",
      en: "If you want contemporary Italian cologne freshness with a soft elegant trail.",
    },
  },

  "Bleu de Chanel Eau de Parfum": {
    miniTag: { sr: "🔵 Aromatičan / Drvenast", en: "🔵 Aromatic / Woody" },
    card: {
      sr: "Grejp, nana i tamjan u bezvremenski elegantnom plavom mirisu.",
      en: "Grapefruit, mint and incense in a timelessly elegant blue fragrance.",
    },
    modal: {
      sr: "Grejp, limun i nana otvaraju miris čistom energijom, đumbir i muškatni oraščić daju dubinu, a tamjan, kedar i sandalovina njegov prepoznatljiv trag.",
      en: "Grapefruit, lemon and mint open with clean energy, ginger and nutmeg add depth, while incense, cedarwood and sandalwood form its unmistakable trail.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["grejp", "nana", "tamjan", "sandalovina"],
      en: ["grapefruit", "mint", "incense", "sandalwood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Čist", "Večernji"],
      en: ["Signature", "Clean", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš jedan istinski svestran parfem koji jednako dobro radi danju i uveče.",
      en: "If you want a truly versatile fragrance that works equally well by day and at night.",
    },
  },

  "Essential Parfums Bois Impérial Eau de Parfum": {
    miniTag: { sr: "🌿 Začinski / Drvenast", en: "🌿 Spicy / Woody" },
    card: {
      sr: "Bosiljak, Timut biber i vetiver u suvom drvenom tragu.",
      en: "Thai basil, Timut pepper and vetiver in a modern woody fragrance.",
    },
    modal: {
      sr: "Zeleni bosiljak i iskričavi Timut biber vode u vetiver i Georgywood, dok Akigalawood, pačuli i Ambrofix daju suv, snažan i savremen trag.",
      en: "Green basil and sparkling Timut pepper lead into vetiver and Georgywood, while Akigalawood, patchouli and Ambrofix create a dry, powerful and contemporary trail.",
    },
    scentType: {
      sr: "Zeleni, začinski i drvenast",
      en: "Green spicy woody",
    },
    dominantNotes: {
      sr: ["tajlandski bosiljak", "Timut biber", "vetiver", "Akigalawood"],
      en: ["Thai basil", "Timut pepper", "vetiver", "Akigalawood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Čist", "Bogat"],
      en: ["Signature", "Clean", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš originalan, moderan i izuzetno prepoznatljiv drvenasti parfem.",
      en: "If you want an original, modern and highly distinctive woody fragrance.",
    },
  },

  "BOSS Bottled Beyond Eau de Parfum": {
    miniTag: { sr: "🫚 Đumbir / Koža", en: "🫚 Ginger / Leather" },
    card: {
      sr: "Svež đumbir i glatka koža iznad moderne drvenaste baze.",
      en: "Fresh ginger and smooth leather over a modern woody base.",
    },
    modal: {
      sr: "Prodoran đumbir donosi energiju, kožni akord daje uglađenu dubinu, a čiste drvenaste note ostavljaju moderan i samouveren trag.",
      en: "Vibrant ginger brings energy, a leather accord adds polished depth, and clean woody notes leave a modern, confident trail.",
    },
    scentType: {
      sr: "Začinski, kožni i drvenast",
      en: "Spicy leather woody",
    },
    dominantNotes: {
      sr: ["đumbir", "koža", "drvenaste note"],
      en: ["ginger", "leather", "woody notes"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Večernji", "Bogat"],
      en: ["Signature", "Night", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš čist i moderan kožni parfem bez suvišne težine.",
      en: "If you want a clean modern leather fragrance without unnecessary heaviness.",
    },
  },

  "BOSS The Scent Elixir Parfum Intense for Him": {
    miniTag: { sr: "🌶️ Začinski / Drvenast", en: "🌶️ Spicy / Woody" },
    card: {
      sr: "Pimento, lavandin i sandalovina u intenzivnom večernjem mirisu.",
      en: "Pimento, lavandin and sandalwood in an intense evening scent.",
    },
    modal: {
      sr: "Vatreni pimento otvara miris snažno, aromatični lavandin unosi kontrast, a kremasta sandalovina gradi topao, senzualan i dugotrajan završetak.",
      en: "Fiery pimento opens with force, aromatic lavandin adds contrast, and creamy sandalwood creates a warm, sensual and lasting finish.",
    },
    scentType: {
      sr: "Začinski, aromatičan i drvenast",
      en: "Spicy, aromatic and woody",
    },
    dominantNotes: {
      sr: ["pimento", "lavandin", "sandalovina"],
      en: ["pimento", "lavandin", "sandalwood"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš intenzivan i senzualan parfem sa jasnim začinsko-drvenastim potpisom.",
      en: "If you want an intense sensual fragrance with a clear spicy-woody signature.",
    },
  },

    "BOSS The Scent Le Parfum for Him": {
    miniTag: { sr: "🖤 Iris / Koža", en: "🖤 Iris / Leather" },
    card: {
      sr: "Egzotična maninka, puderasti iris i glatka koža u senzualnom spoju.",
      en: "Exotic maninka, powdery iris and smooth leather in a sensual blend.",
    },
    modal: {
      sr: "Voćna toplina maninke vodi u elegantno puderasti iris, dok kožni akord daje mirisu meku dubinu i zavodljiv večernji karakter.",
      en: "The fruity warmth of maninka leads into elegantly powdery iris, while a leather accord gives the scent soft depth and a seductive evening character.",
    },
    scentType: {
      sr: "Voćni, puderast i kožni",
      en: "Fruity powdery leather",
    },
    dominantNotes: {
      sr: ["maninka", "iris", "koža"],
      en: ["maninka", "iris", "leather"],
    },
    tags: {
      sr: ["Večernji", "Mekan", "Bogat"],
      en: ["Night", "Soft", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš uglađen i intiman večernji parfem sa puderasto-kožnim potpisom.",
      en: "If you want a polished intimate evening fragrance with a powdery-leather signature.",
    },
  },

  "Calvin Klein CK All Eau de Toilette": {
    miniTag: { sr: "🍊 Citrusni / Mošusni", en: "🍊 Citrus / Musky" },
    card: {
      sr: "Bergamot, cvet grejpa i beli mošus u laganom uniseks mirisu.",
      en: "Bergamot, grapefruit blossom and white musk in a light unisex scent.",
    },
    modal: {
      sr: "Bergamot i mandarina otvaraju miris blistavo, jasmin, rabarbara i frezija daju prozračnu svežinu, a mošus, amber i vetiver čist završetak.",
      en: "Bergamot and mandarin open brightly, jasmine, rhubarb and freesia add airy freshness, while musk, amber and vetiver create a clean finish.",
    },
    scentType: {
      sr: "Citrusni, cvetni i mošusni",
      en: "Citrus floral musky",
    },
    dominantNotes: {
      sr: ["bergamot", "cvet grejpa", "jasmin", "mošus"],
      en: ["bergamot", "grapefruit blossom", "jasmine", "musk"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Mekan"],
      en: ["Clean", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš lagan, nenametljiv i pristupačan miris za svaki topli dan.",
      en: "If you want a light, effortless and accessible fragrance for everyday warm weather.",
    },
  },

  "Calvin Klein Defy Eau de Toilette": {
    miniTag: { sr: "🌿 Aromatičan / Svež", en: "🌿 Aromatic / Fresh" },
    card: {
      sr: "Bergamot, lavanda i vetiver u čistom, urbanom dnevnom mirisu.",
      en: "Bergamot, lavender and vetiver in a clean urban daytime scent.",
    },
    modal: {
      sr: "Bergamot, mandarina i list kedra daju vedar početak, lavanda, žalfija i list ljubičice aromatično srce, a vetiver, amber i mošus moderan trag.",
      en: "Bergamot, mandarin and cedar leaf create a bright opening, lavender, clary sage and violet leaf form an aromatic heart, while vetiver, amber and musk leave a modern trail.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["bergamot", "lavanda", "žalfija", "vetiver"],
      en: ["bergamot", "lavender", "clary sage", "vetiver"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš pouzdan i moderan parfem za posao, grad i svakodnevne obaveze.",
      en: "If you want a dependable modern fragrance for work, the city and daily wear.",
    },
  },

  "Calvin Klein Defy Parfum": {
    miniTag: { sr: "🍫 Kakao / Sandalovina", en: "🍫 Cocoa / Sandalwood" },
    card: {
      sr: "Topli začini, kakao i sandalovina. Gladak i moderan trag.",
      en: "Warm spice, cocoa and sandalwood with a smooth modern finish.",
    },
    modal: {
      sr: "Mandarina, ružičasti biber i kardamom otvaraju miris toplinom, lavanda i đumbir daju živost, a ljuska kakaa, vetiver i sandalovina meku dubinu.",
      en: "Mandarin, pink pepper and cardamom open with warmth, lavender and ginger add vibrancy, while cocoa shell, vetiver and sandalwood provide soft depth.",
    },
    scentType: {
      sr: "Začinski, aromatičan i drvenast",
      en: "Spicy aromatic woody",
    },
    dominantNotes: {
      sr: ["kardamom", "lavanda", "ljuska kakaa", "sandalovina"],
      en: ["cardamom", "lavender", "cocoa shell", "sandalwood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Večernji", "Mekan"],
      en: ["Signature", "Night", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš topliju i sofisticiraniju verziju modernog aromatičnog parfema.",
      en: "If you want a warmer, more sophisticated take on a modern aromatic fragrance.",
    },
  },

  "Chopard Oud Malaki Eau de Parfum": {
    miniTag: { sr: "🚬 Oud / Duvan", en: "🚬 Oud / Tobacco" },
    card: {
      sr: "Duvan, koža i oud u ozbiljnom, raskošnom večernjem mirisu.",
      en: "Tobacco, leather and oud in a serious opulent evening scent.",
    },
    modal: {
      sr: "Grejp, lavanda i artemizija otvaraju miris aromatično, duvan, začini i koža grade tamno srce, a oud, duboko drvo i ambergris snažnu bazu.",
      en: "Grapefruit, lavender and artemisia create an aromatic opening, tobacco, spices and leather form a dark heart, while oud, deep woods and ambergris build a powerful base.",
    },
    scentType: {
      sr: "Aromatičan, duvanski i drvenast",
      en: "Aromatic tobacco woody",
    },
    dominantNotes: {
      sr: ["duvan", "koža", "oud", "tamno drvo"],
      en: ["tobacco", "leather", "oud", "dark woods"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš ozbiljan i muževan oud parfem sa kožnim i duvanskim karakterom.",
      en: "If you want a serious masculine oud fragrance with leather and tobacco character.",
    },
  },

  "Creed Aventus Cologne Eau de Parfum": {
    miniTag: { sr: "🍊 Citrusni / Mineralni", en: "🍊 Citrus / Mineral" },
    card: {
      sr: "Kalabrijski bergamot, mandarina i đumbir u luksuznoj svežini.",
      en: "Calabrian bergamot, mandarin and ginger in luxurious freshness.",
    },
    modal: {
      sr: "Bergamot, mandarina i slani morski akord otvaraju miris blistavo, đumbir, ananas i ružičasti biber daju energiju, a mošus, pačuli i breza dubinu.",
      en: "Bergamot, mandarin and a salty marine accord open brightly, ginger, pineapple and pink pepper add energy, while musk, patchouli and birch provide depth.",
    },
    scentType: {
      sr: "Citrusni, začinski i drvenast",
      en: "Citrus spicy woody",
    },
    dominantNotes: {
      sr: ["kalabrijski bergamot", "mandarina", "đumbir", "breza"],
      en: ["Calabrian bergamot", "mandarin", "ginger", "birch"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš vedriju i elegantniju interpretaciju Aventus karaktera za toplo vreme.",
      en: "If you want a brighter, more elegant interpretation of the Aventus character for warm weather.",
    },
  },

  "Giorgio Armani Acqua di Giò Profondo Parfum": {
    miniTag: { sr: "🌊 Morski / Dubok", en: "🌊 Marine / Deep" },
    card: {
      sr: "Morske note, zelena mandarina i labdanum u dubokoj svežini.",
      en: "Marine notes, green mandarin and labdanum in deep freshness.",
    },
    modal: {
      sr: "Morske note i zelena mandarina daju čist, slan početak, nežna mimoza omekšava srce, a pačuli i labdanum donose toplu i ozbiljnu dubinu.",
      en: "Marine notes and green mandarin create a clean salty opening, delicate mimosa softens the heart, while patchouli and labdanum bring warm, serious depth.",
    },
    scentType: {
      sr: "Morski, aromatičan i ambrast",
      en: "Marine aromatic amber",
    },
    dominantNotes: {
      sr: ["morske note", "zelena mandarina", "mimoza", "labdanum"],
      en: ["marine notes", "green mandarin", "mimosa", "labdanum"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš morsku svežinu sa više dubine, topline i večernjeg karaktera.",
      en: "If you want marine freshness with greater depth, warmth and evening character.",
    },
  },

  "Gisada Ambassador Men Eau de Parfum": {
    miniTag: { sr: "🥭 Mango / Ambrast", en: "🥭 Mango / Amber" },
    card: {
      sr: "Mango, jabuka i vanila u snažnom voćno-ambrastom mirisu.",
      en: "Mango, apple and vanilla in a powerful fruity-amber fragrance.",
    },
    modal: {
      sr: "Zelena mandarina, jabuka i kardamom vode u upečatljiv mango, lavandu i crni biber, dok vanila, amber, tikovina i vetiver grade bogat trag.",
      en: "Green mandarin, apple and cardamom lead into striking mango, lavender and black pepper, while vanilla, amber, teak wood and vetiver build a rich trail.",
    },
    scentType: {
      sr: "Voćni, aromatičan i ambrast",
      en: "Fruity aromatic amber",
    },
    dominantNotes: {
      sr: ["mango", "jabuka", "vanila", "amber"],
      en: ["mango", "apple", "vanilla", "amber"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš sladak i izuzetno primetan parfem napravljen da privuče pažnju.",
      en: "If you want a sweet, highly noticeable fragrance designed to draw attention.",
    },
  },

  "Givenchy Gentleman Réserve Privée Eau de Parfum": {
    miniTag: { sr: "🥃 Viski / Iris", en: "🥃 Whisky / Iris" },
    card: {
      sr: "Viski, iris i kesten u toplom, elegantnom večernjem mirisu.",
      en: "Whisky, iris and chestnut in a warm elegant evening scent.",
    },
    modal: {
      sr: "Bergamot i viski otvaraju miris toplinom, kesten, iris i benzoin stvaraju kremasto-puderasto srce, a kedar, vetiver i pačuli daju profinjenu bazu.",
      en: "Bergamot and whisky open with warmth, chestnut, iris and benzoin form a creamy powdery heart, while cedarwood, vetiver and patchouli create a refined base.",
    },
    scentType: {
      sr: "Puderast, ambrast i drvenast",
      en: "Powdery amber woody",
    },
    dominantNotes: {
      sr: ["viski", "iris", "kesten", "benzoin"],
      en: ["whisky", "iris", "chestnut", "benzoin"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Mekan"],
      en: ["Rich", "Night", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš topao i sofisticiran miris za elegantne večeri i posebne prilike.",
      en: "If you want a warm sophisticated fragrance for elegant evenings and special occasions.",
    },
  },

  "Jimmy Choo Man Blue Eau de Toilette": {
    miniTag: { sr: "💙 Lavanda / Koža", en: "💙 Lavender / Leather" },
    card: {
      sr: "Lavanda, crni biber i meka koža u opuštenom modernom mirisu.",
      en: "Lavender, black pepper and soft leather in a relaxed modern scent.",
    },
    modal: {
      sr: "Lavanda, crni biber i bergamot daju aromatičan početak, koža, čempres i voćne note unose karakter, a sandalovina, vetiver i pačuli meku dubinu.",
      en: "Lavender, black pepper and bergamot create an aromatic opening, leather, cypress and fruity notes add character, while sandalwood, vetiver and patchouli bring soft depth.",
    },
    scentType: {
      sr: "Aromatičan, kožni i drvenast",
      en: "Aromatic leather woody",
    },
    dominantNotes: {
      sr: ["lavanda", "crni biber", "koža", "sandalovina"],
      en: ["lavender", "black pepper", "leather", "sandalwood"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Mekan"],
      en: ["Clean", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš ležeran, prijatan i lako nosiv miris za svaki dan.",
      en: "If you want a relaxed, pleasant and easy-to-wear everyday fragrance.",
    },
  },

    "Yves Saint Laurent L'Homme Eau de Parfum": {
    miniTag: { sr: "🍊 Gorka narandža / Drvo", en: "🍊 Bitter Orange / Woods" },
    card: {
      sr: "Gorka narandža, vetiver i hrastovo drvo. Tiha elegancija.",
      en: "Bitter orange, oakwood and vetiver in a refined elegant fragrance.",
    },
    modal: {
      sr: "Gorka narandža daje svetao i blago opor početak, hrastovo drvo gradi glatko srce, a vetiver ostavlja suv, uglađen i diskretno topao trag.",
      en: "Bitter orange creates a bright slightly tart opening, oakwood forms a smooth heart, and vetiver leaves a dry, polished and subtly warm trail.",
    },
    scentType: {
      sr: "Citrusni, drvenast i vetiverski",
      en: "Citrus woody vetiver",
    },
    dominantNotes: {
      sr: ["gorka narandža", "hrastovo drvo", "vetiver"],
      en: ["bitter orange", "oakwood", "vetiver"],
    },
    tags: {
      sr: ["Mekan", "Večernji", "Prepoznatljiv"],
      en: ["Soft", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš diskretan, uglađen i zreo drvenasti parfem za različite prilike.",
      en: "If you want a discreet, polished and mature woody fragrance for different occasions.",
    },
  },

  "L'Homme Idéal de Guerlain Paris Eau de Toilette": {
    miniTag: { sr: "🌰 Badem / Koža", en: "🌰 Almond / Leather" },
    card: {
      sr: "Badem, tonka i koža u toplom, prepoznatljivom Guerlain mirisu.",
      en: "Almond, tonka and leather in a warm distinctive Guerlain fragrance.",
    },
    modal: {
      sr: "Citrusi, ruzmarin i cvet narandže otvaraju miris vedro, badem i tonka daju kremastu slatkoću, a vetiver, kedar i koža elegantnu dubinu.",
      en: "Citrus, rosemary and orange blossom open brightly, almond and tonka add creamy sweetness, while vetiver, cedarwood and leather bring elegant depth.",
    },
    scentType: {
      sr: "Citrusni, orašast i drvenast",
      en: "Citrus nutty woody",
    },
    dominantNotes: {
      sr: ["badem", "tonka", "koža", "vetiver"],
      en: ["almond", "tonka bean", "leather", "vetiver"],
    },
    tags: {
      sr: ["Mekan", "Večernji", "Prepoznatljiv"],
      en: ["Soft", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš originalan i elegantan miris u kojem badem daje poseban karakter.",
      en: "If you want an original elegant fragrance where almond creates a distinctive character.",
    },
  },

  "Mancera Cedrat Boise Eau de Parfum": {
    miniTag: { sr: "🍋 Citrusni / Kožni", en: "🍋 Citrus / Leather" },
    card: {
      sr: "Sicilijanski citrusi, crna ribizla i koža u moćnom svestranom mirisu.",
      en: "Sicilian citrus, black currant and leather in a powerful versatile scent.",
    },
    modal: {
      sr: "Sicilijanski citrusi, crna ribizla i hladni začini vode u jasmin i pačuli, dok drvo, koža, hrastova mahovina i vanila grade bogat trag.",
      en: "Sicilian citrus, black currant and cool spices lead into jasmine and patchouli, while woods, leather, oakmoss and vanilla build a rich trail.",
    },
    scentType: {
      sr: "Citrusni, voćni i drvenast",
      en: "Citrus fruity woody",
    },
    dominantNotes: {
      sr: ["sicilijanski citrusi", "crna ribizla", "koža", "hrastova mahovina"],
      en: ["Sicilian citrus", "black currant", "leather", "oakmoss"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Letnji", "Čist"],
      en: ["Signature", "Summer", "Clean"],
    },
    whyChoose: {
      sr: "Ako želiš snažan i luksuzan parfem koji se lako prilagođava skoro svakoj prilici.",
      en: "If you want a powerful luxurious fragrance that adapts easily to almost any occasion.",
    },
  },

  "Montblanc Explorer Extreme Parfum": {
    miniTag: { sr: "🟤 Pačuli / Amber", en: "🟤 Patchouli / Amber" },
    card: {
      sr: "Bergamot, pačuli i amber u dubokom, koncentrisanom drvenastom mirisu.",
      en: "Bergamot, patchouli and amber in a deep concentrated woody scent.",
    },
    modal: {
      sr: "Bergamot unosi kratku citrusnu svetlost, pačuli gradi tamno i zemljano srce, a amber ostavlja topao, snažan i dugotrajan završetak.",
      en: "Bergamot brings a flash of citrus brightness, patchouli forms a dark earthy heart, and amber leaves a warm, powerful and lasting finish.",
    },
    scentType: {
      sr: "Citrusni, zemljani i ambrast",
      en: "Citrus earthy amber",
    },
    dominantNotes: {
      sr: ["bergamot", "pačuli", "amber"],
      en: ["bergamot", "patchouli", "amber"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Večernji", "Bogat"],
      en: ["Signature", "Night", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš taman i intenzivan parfem sa jasnim pačuli–amber potpisom.",
      en: "If you want a dark intense fragrance with a clear patchouli-amber signature.",
    },
  },

  "Narciso Rodriguez for Him Bleu Noir Eau de Parfum": {
    miniTag: { sr: "🖤 Mošus / Tamno drvo", en: "🖤 Musk / Dark Woods" },
    card: {
      sr: "Mošus, plavi kedar i crna ebanovina u tiho elegantnom mirisu.",
      en: "Musk, blue cedar and black ebony in a quietly elegant fragrance.",
    },
    modal: {
      sr: "Bergamot i crni biber otvaraju miris čisto, mošus, plavi kedar i crna ebanovina daju tamnu mekoću, a vetiver i amber uglađen završetak.",
      en: "Bergamot and black pepper open cleanly, musk, blue cedar and black ebony provide dark softness, while vetiver and amber create a polished finish.",
    },
    scentType: {
      sr: "Mošusni, začinski i drvenast",
      en: "Musky spicy woody",
    },
    dominantNotes: {
      sr: ["mošus", "crni biber", "plavi kedar", "crna ebanovina"],
      en: ["musk", "black pepper", "blue cedar", "black ebony"],
    },
    tags: {
      sr: ["Mekan", "Čist", "Prepoznatljiv"],
      en: ["Soft", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš suptilan, čist i sofisticiran mošusno-drvenasti parfem.",
      en: "If you want a subtle, clean and sophisticated musky-woody fragrance.",
    },
  },

  "Terre d'Hermès Eau de Toilette": {
    miniTag: { sr: "🪨 Grejp / Kremen", en: "🪨 Grapefruit / Flint" },
    card: {
      sr: "Grejp, kremen i kedar. Suv, zemljan i odmah prepoznatljiv.",
      en: "Grapefruit, flint and cedarwood. Dry, earthy and iconic.",
    },
    modal: {
      sr: "Opori grejp otvara miris svetlo, kremen donosi suv mineralni karakter, a kedar zaokružuje kompoziciju čvrstim i elegantnim drvenastim tragom.",
      en: "Tart grapefruit opens brightly, flint adds a dry mineral character, and cedarwood completes the composition with a firm elegant woody trail.",
    },
    scentType: {
      sr: "Citrusni, mineralni i drvenast",
      en: "Citrus mineral woody",
    },
    dominantNotes: {
      sr: ["grejp", "kremen", "kedar"],
      en: ["grapefruit", "flint", "cedarwood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Čist", "Mekan"],
      en: ["Signature", "Clean", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš bezvremenski i zreo parfem sa jedinstvenim mineralnim karakterom.",
      en: "If you want a timeless mature fragrance with a unique mineral character.",
    },
  },

  "Tom Ford Noir Extreme Eau de Parfum": {
    miniTag: { sr: "🍨 Kulfi / Začinski", en: "🍨 Kulfi / Spicy" },
    card: {
      sr: "Kardamom i kulfi u kremastoj vanili za tamnije večeri.",
      en: "Cardamom, kulfi and vanilla in an opulent creamy evening scent.",
    },
    modal: {
      sr: "Šafran, kardamom i muškatni oraščić otvaraju miris toplinom, kremasti kulfi i cveće daju raskoš, a sandalovina, vanila i amber senzualnu dubinu.",
      en: "Saffron, cardamom and nutmeg open with warmth, creamy kulfi and florals add opulence, while sandalwood, vanilla and amber provide sensual depth.",
    },
    scentType: {
      sr: "Začinski, kremast i ambrast",
      en: "Spicy creamy amber",
    },
    dominantNotes: {
      sr: ["kardamom", "kulfi", "vanila", "sandalovina"],
      en: ["cardamom", "kulfi", "vanilla", "sandalwood"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Mekan"],
      en: ["Rich", "Night", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš luksuzan i zavodljiv gurmanski parfem za elegantne hladne večeri.",
      en: "If you want a luxurious seductive gourmand fragrance for elegant cool evenings.",
    },
  },

  "Afnan 9PM Night Out Extrait de Parfum": {
    miniTag: { sr: "🥃 Konjak / Karamela", en: "🥃 Cognac / Toffee" },
    card: {
      sr: "Zmajevo voće, konjak i karamela u snažnom parfemu za noćni izlazak.",
      en: "Dragon fruit, cognac and toffee in a powerful night-out fragrance.",
    },
    modal: {
      sr: "Zmajevo voće, bergamot, konjak i jabuka daju razigran početak, kardamom, antilop i karamela grade zavodljivo srce, a tonka i tamno drvo snažan trag.",
      en: "Dragon fruit, bergamot, cognac and apple create a playful opening, cardamom, suede and toffee form a seductive heart, while tonka and dark woods leave a powerful trail.",
    },
    scentType: {
      sr: "Voćni, gurmanski i drvenast",
      en: "Fruity gourmand woody",
    },
    dominantNotes: {
      sr: ["zmajevo voće", "konjak", "karamela", "antilop"],
      en: ["dragon fruit", "cognac", "toffee", "suede"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš sladak, odvažan i veoma primetan miris sa pravom klabing energijom.",
      en: "If you want a sweet, bold and highly noticeable fragrance with true clubbing energy.",
    },
  },

  "Rasasi Hawas Ice for Him Eau de Parfum": {
    miniTag: { sr: "🧊 Jabuka / Citrusni", en: "🧊 Apple / Citrus" },
    card: {
      sr: "Zaleđena jabuka, italijanski limun i šljiva u živahnom letnjem mirisu.",
      en: "Frozen apple, Italian lemon and plum in a vibrant summer fragrance.",
    },
    modal: {
      sr: "Zaleđena jabuka, limun, bergamot i zvezdasti anis daju leden početak, šljiva i kardamom unose slatkoću, a mošus, amber, drvo i mahovina dubinu.",
      en: "Frozen apple, lemon, bergamot and star anise create an icy opening, plum and cardamom add sweetness, while musk, amber, woods and moss provide depth.",
    },
    scentType: {
      sr: "Voćni, citrusni i drvenast",
      en: "Fruity citrus woody",
    },
    dominantNotes: {
      sr: ["zaleđena jabuka", "italijanski limun", "šljiva", "mošus"],
      en: ["frozen apple", "Italian lemon", "plum", "musk"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš osvežavajući, sladak i primetan letnji parfem sa odličnim karakterom.",
      en: "If you want a refreshing, sweet and noticeable summer fragrance with strong character.",
    },
  },

  "Armaf Club de Nuit Precieux 1 Extrait de Parfum": {
    miniTag: { sr: "🍍 Ananas / Začinski", en: "🍍 Pineapple / Spicy" },
    card: {
      sr: "Ananas, karamela i začini u moćnom voćno-drvenastom parfemu.",
      en: "Pineapple, caramel and spices in a powerful fruity-woody fragrance.",
    },
    modal: {
      sr: "Ananas, limun, bergamot, karamela i biber stvaraju bogat početak, mahovina i belo drvo grade srce, a ambroksan, koža, amber i vanila duboku bazu.",
      en: "Pineapple, lemon, bergamot, caramel and pepper create a rich opening, oakmoss and white woods form the heart, while ambroxan, leather, amber and vanilla build a deep base.",
    },
    scentType: {
      sr: "Voćni, začinski i drvenast",
      en: "Fruity spicy woody",
    },
    dominantNotes: {
      sr: ["ananas", "karamela", "hrastova mahovina", "ambroksan"],
      en: ["pineapple", "caramel", "oakmoss", "ambroxan"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Bogat", "Večernji"],
      en: ["Signature", "Rich", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš raskošnu i intenzivnu interpretaciju modernog voćno-drvenastog profila.",
      en: "If you want an opulent intense interpretation of a modern fruity-woody profile.",
    },
  },

    "French Avenue Safari Breeze Eau de Parfum": {
    miniTag: { sr: "🥥 Kokos / Crna ribizla", en: "🥥 Coconut / Black Currant" },
    card: {
      sr: "Kokos, crna ribizla i grejp u zelenom, tropskom letnjem mirisu.",
      en: "Coconut and black currant sharpened by green grapefruit.",
    },
    modal: {
      sr: "Crna ribizla, kokos i grejp daju sočan početak, nana i jasmin unose zelenu svežinu, a vetiver, amber i hrastova mahovina prirodnu dubinu.",
      en: "Black currant, coconut and grapefruit create a juicy opening, mint and jasmine add green freshness, while vetiver, amber and oakmoss bring natural depth.",
    },
    scentType: {
      sr: "Voćni, zeleni i drvenast",
      en: "Fruity green woody",
    },
    dominantNotes: {
      sr: ["kokos", "crna ribizla", "grejp", "nana"],
      en: ["coconut", "black currant", "grapefruit", "spearmint"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Mekan"],
      en: ["Clean", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš opušten tropski parfem koji spaja voćnu slatkoću i zelenu svežinu.",
      en: "If you want a relaxed tropical fragrance blending fruity sweetness with green freshness.",
    },
  },

  "Lattafa Dynasty Eau de Parfum": {
    miniTag: { sr: "🍵 Rooibos / Antilop", en: "🍵 Rooibos / Suede" },
    card: {
      sr: "Rooibos čaj, antilop i toplo drvo u neobičnom elegantnom mirisu.",
      en: "Rooibos tea, suede and warm woods in an unusual elegant fragrance.",
    },
    modal: {
      sr: "Bergamot, đumbir, žalfija i malina otvaraju miris živahno, rooibos čaj i antilop grade posebno srce, a amber drvo, kedar i kašmeran toplu bazu.",
      en: "Bergamot, ginger, clary sage and raspberry open with vibrancy, rooibos tea and suede form a distinctive heart, while amberwood, cedarwood and cashmeran create a warm base.",
    },
    scentType: {
      sr: "Čajni, kožni i drvenast",
      en: "Tea leather woody",
    },
    dominantNotes: {
      sr: ["rooibos čaj", "đumbir", "antilop", "amber drvo"],
      en: ["rooibos tea", "ginger", "suede", "amberwood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Bogat", "Večernji"],
      en: ["Signature", "Rich", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš originalan i sofisticiran miris koji se izdvaja rooibos čajem i antilopom.",
      en: "If you want an original sophisticated fragrance distinguished by rooibos tea and suede.",
    },
  },

  "Dolce&Gabbana The One for Men Eau de Toilette": {
    miniTag: { sr: "🚬 Duvan / Začinski", en: "🚬 Tobacco / Spicy" },
    card: {
      sr: "Kardamom, duvan i amber u toplom klasiku za večernje prilike.",
      en: "Cardamom, tobacco and amber in a warm classic for evening occasions.",
    },
    modal: {
      sr: "Grejp, korijander i bosiljak daju elegantan početak, kardamom i đumbir toplinu, a duvan, amber i kedar mekan i zavodljiv završetak.",
      en: "Grapefruit, coriander and basil create an elegant opening, cardamom and ginger add warmth, while tobacco, amber and cedarwood leave a soft seductive finish.",
    },
    scentType: {
      sr: "Začinski, duvanski i ambrast",
      en: "Spicy tobacco amber",
    },
    dominantNotes: {
      sr: ["kardamom", "duvan", "amber", "đumbir"],
      en: ["cardamom", "tobacco", "amber", "ginger"],
    },
    tags: {
      sr: ["Večernji", "Mekan", "Prepoznatljiv"],
      en: ["Night", "Soft", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš topao, elegantan i nenametljivo zavodljiv miris za bliske večernje prilike.",
      en: "If you want a warm elegant and quietly seductive fragrance for intimate evenings.",
    },
  },

  "Versace Man Eau Fraîche Eau de Toilette": {
    miniTag: { sr: "⭐ Karambola / Citrusni", en: "⭐ Starfruit / Citrus" },
    card: {
      sr: "Beli limun, karambola i aromatično drvo u laganom letnjem mirisu.",
      en: "White lemon, starfruit and aromatic woods in a light summer scent.",
    },
    modal: {
      sr: "Beli limun, ružino drvo i karambola otvaraju miris blistavo, estragon i žalfija daju aromatično srce, a mošus, amber i drvo sikamore meku bazu.",
      en: "White lemon, rosewood and starfruit open brightly, tarragon and clary sage create an aromatic heart, while musk, amber and sycamore wood form a soft base.",
    },
    scentType: {
      sr: "Citrusni, voćni i aromatičan",
      en: "Citrus fruity aromatic",
    },
    dominantNotes: {
      sr: ["beli limun", "karambola", "estragon", "mošus"],
      en: ["white lemon", "starfruit", "tarragon", "musk"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Mekan"],
      en: ["Clean", "Summer", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš bezbrižan, lagan i izuzetno prijatan parfem za najtoplije dane.",
      en: "If you want a carefree light and highly pleasant fragrance for the hottest days.",
    },
  },

  "Paris Corner Emir Voux Zingy Eau de Parfum": {
    miniTag: { sr: "🌿 Bosiljak / Citrusni", en: "🌿 Basil / Citrus" },
    card: {
      sr: "Bosiljak, italijanski citron i limun u oštroj zelenoj svežini.",
      en: "Basil, Italian citron and lemon in sharp green freshness.",
    },
    modal: {
      sr: "Bosiljak, bergamot, citron i limun daju energičan početak, jasmin i verbena unose čisto zelenilo, a Ambrettolide i mošus mekan trag.",
      en: "Basil, bergamot, citron and lemon create an energetic opening, jasmine and verbena add clean greenery, while Ambrettolide and musk leave a soft trail.",
    },
    scentType: {
      sr: "Citrusni, zeleni i mošusni",
      en: "Citrus green musky",
    },
    dominantNotes: {
      sr: ["bosiljak", "italijanski citron", "limun", "verbena"],
      en: ["basil", "Italian citron", "lemon", "verbena"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš energičan citrusni parfem sa izrazito zelenim i aromatičnim karakterom.",
      en: "If you want an energetic citrus fragrance with a distinctly green aromatic character.",
    },
  },

  "Rayhaan Crimson Eau de Parfum": {
    miniTag: { sr: "🔥 Cimet / Vanila", en: "🔥 Cinnamon / Vanilla" },
    card: {
      sr: "Cimet, kardamom i vanila u toplom, raskošnom večernjem mirisu.",
      en: "Cinnamon, cardamom and vanilla in a warm opulent evening scent.",
    },
    modal: {
      sr: "Cimet, kardamom i ružičasti biber otvaraju miris vatreno, pačuli i heliotropin daju tamnu mekoću, a benzoin, vanila i tonka bogat završetak.",
      en: "Cinnamon, cardamom and pink pepper open with fiery warmth, patchouli and heliotropin add dark softness, while benzoin, vanilla and tonka create a rich finish.",
    },
    scentType: {
      sr: "Začinski, vanilast i ambrast",
      en: "Spicy vanilla amber",
    },
    dominantNotes: {
      sr: ["cimet", "kardamom", "vanila", "benzoin"],
      en: ["cinnamon", "cardamom", "vanilla", "benzoin"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako voliš intenzivne začinsko-vanilaste parfeme sa toplim i zavodljivim tragom.",
      en: "If you enjoy intense spicy-vanilla fragrances with a warm seductive trail.",
    },
  },

  "Rasasi Hawas Black Eau de Parfum": {
    miniTag: { sr: "🍍 Ananas / Mahovina", en: "🍍 Pineapple / Oakmoss" },
    card: {
      sr: "Ananas i bergamot nad tamnom mahovinom i drvenom bazom.",
      en: "Pineapple, bergamot and oakmoss in a powerful fruity-woody fragrance.",
    },
    modal: {
      sr: "Ananas, grejp i bergamot daju blistav voćni početak, kedar, pačuli i jasmin grade srce, a hrastova mahovina, drvo i amber snažnu bazu.",
      en: "Pineapple, grapefruit and bergamot create a bright fruity opening, cedarwood, patchouli and jasmine form the heart, while oakmoss, woods and amber build a powerful base.",
    },
    scentType: {
      sr: "Voćni, mahovinast i drvenast",
      en: "Fruity mossy woody",
    },
    dominantNotes: {
      sr: ["ananas", "bergamot", "pačuli", "hrastova mahovina"],
      en: ["pineapple", "bergamot", "patchouli", "oakmoss"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Večernji", "Bogat"],
      en: ["Signature", "Night", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš snažan i ozbiljan ananas–mahovina profil sa odličnim prisustvom.",
      en: "If you want a powerful serious pineapple-oakmoss profile with excellent presence.",
    },
  },

  "Khadlaj Onyx Silver Eau de Parfum": {
    miniTag: { sr: "🫚 Đumbir / Kardamom", en: "🫚 Ginger / Cardamom" },
    card: {
      sr: "Bergamot, đumbir i kardamom u čistom začinsko-smolastom mirisu.",
      en: "Bergamot, ginger and cardamom in a clean spicy-resinous scent.",
    },
    modal: {
      sr: "Bergamot, đumbir i crni biber otvaraju miris energično, petitgrain i kardamom daju aromatičnu živost, a pačuli, labdanum, benzoin i tonka toplinu.",
      en: "Bergamot, ginger and black pepper open with energy, petitgrain and cardamom add aromatic vibrancy, while patchouli, labdanum, benzoin and tonka bring warmth.",
    },
    scentType: {
      sr: "Citrusni, začinski i smolast",
      en: "Citrus spicy resinous",
    },
    dominantNotes: {
      sr: ["bergamot", "đumbir", "kardamom", "labdanum"],
      en: ["bergamot", "ginger", "cardamom", "labdanum"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Čist", "Večernji"],
      en: ["Signature", "Clean", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš svestran i moderan parfem koji spaja svežinu, začine i toplu bazu.",
      en: "If you want a versatile modern fragrance combining freshness, spice and a warm base.",
    },
  },

  "Arabiyat Prestige Fahad Gaze Eau de Parfum": {
    miniTag: { sr: "🪞 Metalni / Tamjan", en: "🪞 Metallic / Incense" },
    card: {
      sr: "Metalne note, elemi i tamjan u elegantnom, intenzivnom mirisu.",
      en: "Metallic notes, elemi and incense in an elegant intense fragrance.",
    },
    modal: {
      sr: "Začini, elemi i metalne note stvaraju oštar početak, cvet narandže, tamjan i pačuli daju dubinu, a ambergris, vanila i mahovina bogat završetak.",
      en: "Spices, elemi and metallic notes create a sharp opening, orange blossom, incense and patchouli add depth, while ambergris, vanilla and moss form a rich finish.",
    },
    scentType: {
      sr: "Začinski, smolast i ambrast",
      en: "Spicy resinous amber",
    },
    dominantNotes: {
      sr: ["elemi", "metalne note", "tamjan", "vanila"],
      en: ["elemi", "metallic notes", "incense", "vanilla"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš elegantan i ozbiljan parfem sa neobičnim metalno-smolastim karakterom.",
      en: "If you want an elegant serious fragrance with an unusual metallic-resinous character.",
    },
  },

  "Narciso Rodriguez NARCISO Poudrée Eau de Parfum": {
    miniTag: { sr: "🌸 Puderasti mošus / Cvetni", en: "🌸 Powdery Musk / Floral" },
    card: {
      sr: "Beli jasmin, bugarska ruža i puderasti mošus u elegantnom mirisu.",
      en: "White jasmine and rose wrapped in soft powdery musk.",
    },
    modal: {
      sr: "Beli jasmin i bugarska ruža otvaraju miris nežno, puderasti mošus stvara njegov prepoznatljiv oblak, a vetiver i crni i beli kedar daju toplu dubinu.",
      en: "White jasmine and Bulgarian rose open gently, powdery musk creates its signature cloud, while vetiver with black and white cedar provides warm depth.",
    },
    scentType: {
      sr: "Puderast, mošusni i cvetni",
      en: "Powdery musky floral",
    },
    dominantNotes: {
      sr: ["puderasti mošus", "beli jasmin", "bugarska ruža", "kedar"],
      en: ["powdery musk", "white jasmine", "Bulgarian rose", "cedarwood"],
    },
    tags: {
      sr: ["Mekan", "Bogat", "Prepoznatljiv"],
      en: ["Soft", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš čist, ženstven i sofisticiran puderasti miris sa luksuznim mošusnim tragom.",
      en: "If you want a clean feminine sophisticated powdery scent with a luxurious musky trail.",
    },
  },

    "Yves Saint Laurent Black Opium Le Parfum": {
    miniTag: { sr: "☕ Vanila / Kafa", en: "☕ Vanilla / Coffee" },
    card: {
      sr: "Vanila i crna kafa preko mekog belog cveća. Bogato i zavodljivo.",
      en: "Multiple vanillas, black coffee and white florals in a rich seductive scent.",
    },
    modal: {
      sr: "Kruška, cimet i zelena mandarina vode u jasmin i cvet narandže, dok tri raskošne vanile, crna kafa, vanila-orhideja i pačuli grade intenzivnu bazu.",
      en: "Pear, cinnamon and green mandarin lead into jasmine and orange blossom, while three opulent vanillas, black coffee, vanilla orchid and patchouli build an intense base.",
    },
    scentType: {
      sr: "Vanilast, kafeni i cvetni",
      en: "Vanilla coffee floral",
    },
    dominantNotes: {
      sr: ["vanila sa Madagaskara", "crna kafa", "jasmin sambak", "kruška"],
      en: ["Madagascar vanilla", "black coffee", "jasmine sambac", "pear"],
    },
    tags: {
      sr: ["Bogat", "Večernji", "Prepoznatljiv"],
      en: ["Rich", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš intenzivan, ženstven i prepoznatljiv parfem u kojem vanila vodi glavnu reč.",
      en: "If you want an intense feminine signature fragrance where vanilla takes center stage.",
    },
  },

  "French Avenue Pinnace Oryn Eau de Parfum": {
    miniTag: { sr: "🍊 Narandža / Đumbir", en: "🍊 Orange / Ginger" },
    card: {
      sr: "Narandža, mandarina i đumbir u blistavom luksuznom letnjem mirisu.",
      en: "Orange, mandarin and ginger in a radiant luxurious summer scent.",
    },
    modal: {
      sr: "Bergamot, narandža i mandarina stvaraju sočan i blistav početak, đumbir dodaje energiju, a ambergris ostavlja čist, mineralan i dugotrajan trag.",
      en: "Bergamot, orange and mandarin create a juicy radiant opening, ginger adds energy, and ambergris leaves a clean mineral and lasting trail.",
    },
    scentType: {
      sr: "Citrusni, začinski i ambrast",
      en: "Citrus spicy amber",
    },
    dominantNotes: {
      sr: ["narandža", "mandarina", "đumbir", "ambergris"],
      en: ["orange", "mandarin", "ginger", "ambergris"],
    },
    tags: {
      sr: ["Čist", "Prepoznatljiv", "Letnji"],
      en: ["Clean", "Signature", "Summer"],
    },
    whyChoose: {
      sr: "Ako želiš luksuznu citrusnu svežinu koja je jednostavna, energična i upečatljiva.",
      en: "If you want luxurious citrus freshness that feels simple, energetic and distinctive.",
    },
  },

  "RiiFFS Freeze Extrait de Parfum": {
    miniTag: { sr: "🧊 Led / Nana", en: "🧊 Ice / Mint" },
    card: {
      sr: "Nana, citrusi i ledeni akordi u izrazito osvežavajućem mirisu.",
      en: "Mint, citrus and icy accords in an intensely refreshing fragrance.",
    },
    modal: {
      sr: "Nana, kalabrijski bergamot, limun i grejp vode kroz snežni akord, led, đumbir, čaj i žalfiju, dok Ambermax i kedar daju moderan završetak.",
      en: "Mint, Calabrian bergamot, lemon and grapefruit move through snow, ice, ginger, tea and sage accords, while Ambermax and cedarwood create a modern finish.",
    },
    scentType: {
      sr: "Ledeni, citrusni i aromatičan",
      en: "Icy citrus aromatic",
    },
    dominantNotes: {
      sr: ["nana", "ledeni akord", "đumbir", "čaj"],
      en: ["spearmint", "ice accord", "ginger", "tea"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš zaista leden i energičan parfem za vrele letnje dane.",
      en: "If you want a genuinely icy energetic fragrance for hot summer days.",
    },
  },

  "Lattafa Maahir Legacy Eau de Parfum": {
    miniTag: { sr: "🌿 Nana / Aromatičan", en: "🌿 Mint / Aromatic" },
    card: {
      sr: "Limeta, nana i lavanda u čistom, kompleksnom aromatičnom mirisu.",
      en: "Lime, mint and lavender in a clean complex aromatic fragrance.",
    },
    modal: {
      sr: "Limeta, grejp, lavanda, nana i ananas daju živahan početak, kleka, ruzmarin i biber aromatičnu dubinu, a vetiver, kašmeran i ambroksan čvrstu bazu.",
      en: "Lime, grapefruit, lavender, mint and pineapple create a lively opening, juniper, rosemary and pepper add aromatic depth, while vetiver, cashmeran and ambroxan form a solid base.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["limeta", "nana", "lavanda", "vetiver"],
      en: ["lime", "spearmint", "lavender", "vetiver"],
    },
    tags: {
      sr: ["Čist", "Prepoznatljiv", "Letnji"],
      en: ["Clean", "Signature", "Summer"],
    },
    whyChoose: {
      sr: "Ako želiš svež i kompleksan svakodnevni miris sa ozbiljnim aromatičnim karakterom.",
      en: "If you want a fresh complex everyday scent with serious aromatic character.",
    },
  },

  "Yves Saint Laurent Y Iced Cologne Eau de Toilette Intense": {
    miniTag: { sr: "🧊 Ledena nana / Žalfija", en: "🧊 Iced Mint / Sage" },
    card: {
      sr: "Ledena nana i žalfija preko čistog, hladnog ambroksana.",
      en: "Iced mint, blue sage and ambroxan in modern cooling freshness.",
    },
    modal: {
      sr: "Ledena i živa nana daju snažan rashlađujući početak, plava žalfija donosi aromatičnu čistoću, a ambroksan i pačuli moderan i postojan trag.",
      en: "Iced and living mint create a powerful cooling opening, blue sage adds aromatic clarity, while ambroxan and patchouli leave a modern lasting trail.",
    },
    scentType: {
      sr: "Ledeni, aromatičan i drvenast",
      en: "Icy aromatic woody",
    },
    dominantNotes: {
      sr: ["ledena nana", "plava žalfija", "ambroksan", "pačuli"],
      en: ["iced mint", "blue sage", "ambroxan", "patchouli"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš moderan i izrazito hladan letnji miris koji se razlikuje od običnih citrusa.",
      en: "If you want a modern distinctly cooling summer scent that differs from typical citrus fragrances.",
    },
  },

  "Valentino Uomo Born in Roma Coral Fantasy Eau de Toilette": {
    miniTag: { sr: "🍎 Crvena jabuka / Duvan", en: "🍎 Red Apple / Tobacco" },
    card: {
      sr: "Crvena jabuka, kardamom i duvan u modernom zavodljivom mirisu.",
      en: "Red apple, cardamom and tobacco in a modern seductive fragrance.",
    },
    modal: {
      sr: "Crvena jabuka, kardamom i bergamot daju sočan početak, lavanda i žalfija aromatično srce, a list duvana, pačuli i vetiver topao trag.",
      en: "Red apple, cardamom and bergamot create a juicy opening, lavender and clary sage form an aromatic heart, while tobacco leaf, patchouli and vetiver leave a warm trail.",
    },
    scentType: {
      sr: "Voćni, aromatičan i duvanski",
      en: "Fruity aromatic tobacco",
    },
    dominantNotes: {
      sr: ["crvena jabuka", "kardamom", "lavanda", "list duvana"],
      en: ["red apple", "cardamom", "lavender", "tobacco leaf"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš privlačan i veoma nosiv parfem koji spaja sočnu jabuku i topao duvan.",
      en: "If you want an attractive highly wearable fragrance combining juicy apple with warm tobacco.",
    },
  },

  "Dolce&Gabbana Light Blue Pour Homme Eau de Toilette (2025)": {
    miniTag: { sr: "🍋 Limun / Ruzmarin", en: "🍋 Lemon / Rosemary" },
    card: {
      sr: "Limun, ruzmarin i pačuli u čistom mediteranskom letnjem mirisu.",
      en: "Lemon, rosemary and patchouli in a clean Mediterranean summer scent.",
    },
    modal: {
      sr: "Blistavi limun daje vedar i energičan početak, aromatični ruzmarin donosi mediteranski karakter, a pačuli ostavlja čist i diskretno zemljan trag.",
      en: "Bright lemon creates a lively energetic opening, aromatic rosemary brings Mediterranean character, and patchouli leaves a clean subtly earthy trail.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i zemljani",
      en: "Citrus aromatic earthy",
    },
    dominantNotes: {
      sr: ["limun", "ruzmarin", "pačuli"],
      en: ["lemon", "rosemary", "patchouli"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš jednostavnu, elegantnu i bezvremensku mediteransku svežinu.",
      en: "If you want simple elegant and timeless Mediterranean freshness.",
    },
  },

  "BVLGARI Man in Black Eau de Parfum": {
    miniTag: { sr: "🥃 Rum / Koža", en: "🥃 Rum / Leather" },
    card: {
      sr: "Rum, duvan i koža u tamnom, moćnom večernjem mirisu.",
      en: "Rum, tobacco and leather in a dark powerful evening scent.",
    },
    modal: {
      sr: "Začini, rum i duvan otvaraju miris toplinom, koža, iris i tuberoza daju raskošno srce, a tonka, gvajak i benzoin duboku smolastu bazu.",
      en: "Spices, rum and tobacco open with warmth, leather, iris and tuberose create an opulent heart, while tonka, guaiac wood and benzoin form a deep resinous base.",
    },
    scentType: {
      sr: "Začinski, kožni i ambrast",
      en: "Spicy leather amber",
    },
    dominantNotes: {
      sr: ["rum", "duvan", "koža", "benzoin"],
      en: ["rum", "tobacco", "leather", "benzoin"],
    },
    tags: {
      sr: ["Večernji", "Bogat", "Prepoznatljiv"],
      en: ["Night", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš ozbiljan, muževan i zavodljiv parfem za hladne večeri.",
      en: "If you want a serious masculine seductive fragrance for cold evenings.",
    },
  },

  "Mancera Aoud Lemon Mint Eau de Parfum": {
    miniTag: { sr: "🍋 Limun / Oud", en: "🍋 Lemon / Oud" },
    card: {
      sr: "Sicilijanski limun, oud i sveža nana u odvažnom niche mirisu.",
      en: "Sicilian lemon, oud and fresh mint in a bold niche fragrance.",
    },
    modal: {
      sr: "Limun, korijander, crni biber i badem otvaraju miris snažno, oud, jasmin, pačuli i nana grade srce, a koža, amber, vanila i vetiver bogatu bazu.",
      en: "Lemon, coriander, black pepper and almond open powerfully, oud, jasmine, patchouli and mint form the heart, while leather, amber, vanilla and vetiver build a rich base.",
    },
    scentType: {
      sr: "Citrusni, drvenast i kožni",
      en: "Citrus woody leather",
    },
    dominantNotes: {
      sr: ["sicilijanski limun", "oud", "sveža nana", "koža"],
      en: ["Sicilian lemon", "oud", "fresh mint", "leather"],
    },
    tags: {
      sr: ["Letnji", "Bogat", "Prepoznatljiv"],
      en: ["Summer", "Rich", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš snažan i neobičan niche parfem koji spaja svetle citruse i tamni oud.",
      en: "If you want a powerful unusual niche fragrance combining bright citrus with dark oud.",
    },
  },

  "Prada Paradigme Eau de Parfum": {
    miniTag: { sr: "🟢 Geranijum / Balzami", en: "🟢 Geranium / Balsams" },
    card: {
      sr: "Bergamot, geranijum i topli balzami u modernom Prada mirisu.",
      en: "Bergamot, geranium and warm balsams in a modern Prada fragrance.",
    },
    modal: {
      sr: "Kalabrijski bergamot i mošus otvaraju miris čisto, dve vrste geranijuma daju zeleno-cvetno srce, a peruanski balzam, benzoin i gvajak toplu dubinu.",
      en: "Calabrian bergamot and musk open cleanly, two geranium varieties create a green floral heart, while Peru balsam, benzoin and guaiac wood bring warm depth.",
    },
    scentType: {
      sr: "Aromatičan, balzamičan i drvenast",
      en: "Aromatic balsamic woody",
    },
    dominantNotes: {
      sr: ["kalabrijski bergamot", "geranijum", "peruanski balzam", "benzoin"],
      en: ["Calabrian bergamot", "geranium", "Peru balsam", "benzoin"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Bogat", "Čist"],
      en: ["Signature", "Rich", "Clean"],
    },
    whyChoose: {
      sr: "Ako želiš moderan i luksuzan Prada potpis koji spaja čistu aromatičnost i toplu bazu.",
      en: "If you want a modern luxurious Prada signature combining clean aromatics with a warm base.",
    },
  },

    "Yves Saint Laurent MYSLF Eau de Parfum": {
    miniTag: { sr: "🌼 Cvet narandže / Drvo", en: "🌼 Orange Blossom / Woods" },
    card: {
      sr: "Kalabrijski bergamot, cvet narandže i toplo drvo u modernom mirisu.",
      en: "Calabrian bergamot, orange blossom and warm woods in a modern scent.",
    },
    modal: {
      sr: "Kalabrijski bergamot otvara miris čisto i blistavo, apsolut tuniskog cveta narandže daje cvetno srce, a toplo drvo, pačuli i Ambrofix moderan trag.",
      en: "Calabrian bergamot opens cleanly and brightly, Tunisian orange blossom absolute forms the floral heart, while warm woods, patchouli and Ambrofix leave a modern trail.",
    },
    scentType: {
      sr: "Citrusni, cvetni i drvenast",
      en: "Citrus floral woody",
    },
    dominantNotes: {
      sr: ["kalabrijski bergamot", "cvet narandže", "toplo drvo", "pačuli"],
      en: ["Calabrian bergamot", "orange blossom", "warm woods", "patchouli"],
    },
    tags: {
      sr: ["Čist", "Prepoznatljiv", "Večernji"],
      en: ["Clean", "Signature", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš čist, privlačan i veoma nosiv moderan parfem za dan i izlazak.",
      en: "If you want a clean attractive and highly wearable modern fragrance for day and night.",
    },
  },

  "Carolina Herrera Bad Boy Cobalt Eau de Parfum Électrique": {
    miniTag: { sr: "🫐 Crna šljiva / Aromatičan", en: "🫐 Black Plum / Aromatic" },
    card: {
      sr: "Crna šljiva, ružičasti biber i vetiver u smelom modernom mirisu.",
      en: "Black plum, pink pepper and vetiver in a bold modern fragrance.",
    },
    modal: {
      sr: "Ružičasti biber i lavanda daju energičan početak, geranijum i crna šljiva sočno aromatično srce, a tartuf, vetiver i kedar tamnu dubinu.",
      en: "Pink pepper and lavender create an energetic opening, geranium and black plum form a juicy aromatic heart, while truffle, vetiver and cedarwood add dark depth.",
    },
    scentType: {
      sr: "Voćni, aromatičan i drvenast",
      en: "Fruity aromatic woody",
    },
    dominantNotes: {
      sr: ["crna šljiva", "ružičasti biber", "lavanda", "vetiver"],
      en: ["black plum", "pink pepper", "lavender", "vetiver"],
    },
    tags: {
      sr: ["Večernji", "Prepoznatljiv", "Čist"],
      en: ["Night", "Signature", "Clean"],
    },
    whyChoose: {
      sr: "Ako želiš mladalački, privlačan i lako nosiv miris sa neobičnom notom šljive.",
      en: "If you want a youthful attractive easy-to-wear scent with an unusual plum note.",
    },
  },

  "Prada Luna Rossa Ocean Eau de Toilette": {
    miniTag: { sr: "💙 Lavanda / Iris", en: "💙 Lavender / Iris" },
    card: {
      sr: "Bergamot, lavanda i iris u čistom, elegantnom Prada mirisu.",
      en: "Bergamot, lavender and iris in a clean elegant Prada fragrance.",
    },
    modal: {
      sr: "Bergamot daje blistav početak, lavanda, žalfija i iris grade uglađeno aromatično srce, a vetiver i tonka mekan i moderan završetak.",
      en: "Bergamot creates a bright opening, lavender, sage and iris form a polished aromatic heart, while vetiver and tonka provide a soft modern finish.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i puderast",
      en: "Citrus aromatic powdery",
    },
    dominantNotes: {
      sr: ["bergamot", "lavanda", "iris", "vetiver"],
      en: ["bergamot", "lavender", "iris", "vetiver"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš besprekoran i nenametljiv dnevni parfem sa prepoznatljivom Prada čistoćom.",
      en: "If you want an impeccable effortless daytime scent with signature Prada cleanliness.",
    },
  },

  "Thomas Kosmala No. 7 Le Sel de la Terre Eau de Parfum": {
    miniTag: { sr: "🌊 Morski / Citrusni", en: "🌊 Marine / Citrus" },
    card: {
      sr: "Italijanski limun, morske note i mošus u prozračnom niche mirisu.",
      en: "Italian lemon, marine notes and musk in an airy niche fragrance.",
    },
    modal: {
      sr: "Bergamot, italijanski limun i sveže morske note otvaraju miris blistavo, vodeni akord i cveće daju prozračnost, a drvo i mošus čist trag.",
      en: "Bergamot, Italian lemon and fresh marine notes open brightly, an aquatic accord and florals add airiness, while woods and musk leave a clean trail.",
    },
    scentType: {
      sr: "Morski, citrusni i mošusni",
      en: "Marine citrus musky",
    },
    dominantNotes: {
      sr: ["italijanski limun", "morske note", "vodeni akord", "mošus"],
      en: ["Italian lemon", "marine notes", "aquatic accord", "musk"],
    },
    tags: {
      sr: ["Letnji", "Prepoznatljiv", "Čist"],
      en: ["Summer", "Signature", "Clean"],
    },
    whyChoose: {
      sr: "Ako želiš luksuzan i upečatljiv morski parfem sa svetlim citrusnim karakterom.",
      en: "If you want a luxurious distinctive marine fragrance with bright citrus character.",
    },
  },

  "Jean Paul Gaultier Le Beau Eau de Toilette": {
    miniTag: { sr: "🥥 Kokos / Tonka", en: "🥥 Coconut / Tonka" },
    card: {
      sr: "Bergamot, kokosovo drvo i tonka u zavodljivom tropskom mirisu.",
      en: "Bergamot, coconut wood and tonka in a seductive tropical fragrance.",
    },
    modal: {
      sr: "Bergamot otvara miris blistavom svežinom, kokosovo drvo donosi kremasti tropski karakter, a tonka ostavlja topao, sladak i privlačan trag.",
      en: "Bergamot opens with radiant freshness, coconut wood brings creamy tropical character, and tonka leaves a warm sweet attractive trail.",
    },
    scentType: {
      sr: "Tropski, drvenast i gurmanski",
      en: "Tropical woody gourmand",
    },
    dominantNotes: {
      sr: ["bergamot", "kokosovo drvo", "tonka"],
      en: ["bergamot", "coconut wood", "tonka bean"],
    },
    tags: {
      sr: ["Letnji", "Večernji", "Prepoznatljiv"],
      en: ["Summer", "Night", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš jednostavan, zavodljiv i veoma privlačan tropski parfem za leto.",
      en: "If you want a simple seductive and highly attractive tropical fragrance for summer.",
    },
  },

  "Rayhaan Azul Eau de Parfum": {
    miniTag: { sr: "🍋 Citrusni / Kalon", en: "🍋 Citrus / Calone" },
    card: {
      sr: "Bergamot, limun i cvet grejpa u čistom svetlom letnjem mirisu.",
      en: "Bergamot, lemon and grapefruit in clean summer brightness.",
    },
    modal: {
      sr: "Bergamot i limun otvaraju miris blistavo, cvet grejpa daje prozračno cvetno srce, a kalon i sandalovina čist, hladan i gladak završetak.",
      en: "Bergamot and lemon open brightly, grapefruit blossom creates an airy floral heart, while calone and sandalwood provide a clean cool smooth finish.",
    },
    scentType: {
      sr: "Citrusni, cvetni i drvenast",
      en: "Citrus floral woody",
    },
    dominantNotes: {
      sr: ["bergamot", "limun", "cvet grejpa", "kalon"],
      en: ["bergamot", "lemon", "grapefruit blossom", "calone"],
    },
    tags: {
      sr: ["Letnji", "Čist", "Prepoznatljiv"],
      en: ["Summer", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš laganu i elegantnu citrusnu svežinu za najtoplije dane.",
      en: "If you want light elegant citrus freshness for the hottest days.",
    },
  },

  "Lattafa Suqraat Eau de Parfum": {
    miniTag: { sr: "🫚 Đumbir / Lavanda", en: "🫚 Ginger / Lavender" },
    card: {
      sr: "Bergamot, đumbir i lavanda u čistom aromatično-drvenastom mirisu.",
      en: "Bergamot, ginger and lavender in a clean aromatic-woody scent.",
    },
    modal: {
      sr: "Bergamot i đumbir daju svetao i začinski početak, lavanda i list ljubičice aromatično srce, a mošus, sandalovina i amber mekanu dubinu.",
      en: "Bergamot and ginger create a bright spicy opening, lavender and violet leaf form an aromatic heart, while musk, sandalwood and amber provide soft depth.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["bergamot", "đumbir", "lavanda", "sandalovina"],
      en: ["bergamot", "ginger", "lavender", "sandalwood"],
    },
    tags: {
      sr: ["Letnji", "Čist", "Prepoznatljiv"],
      en: ["Summer", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš pristupačan i elegantan aromatičan miris za svakodnevno nošenje po toplom vremenu.",
      en: "If you want an accessible elegant aromatic fragrance for everyday wear in warm weather.",
    },
  },

  "Khadlaj Shiyaaka Snow Eau de Parfum": {
    miniTag: { sr: "🍊 Citrusi / Neroli", en: "🍊 Citrus / Neroli" },
    card: {
      sr: "Mandarina, neroli i vetiver u luksuznoj začinskoj svežini.",
      en: "Mandarin, neroli and vetiver in luxurious spicy freshness.",
    },
    modal: {
      sr: "Mandarina, bergamot i citrusi daju blistav početak, neroli, muškatni oraščić i ružičasti biber karakter, a vetiver i kardamom suv elegantan trag.",
      en: "Mandarin, bergamot and citrus create a radiant opening, neroli, nutmeg and pink pepper add character, while vetiver and cardamom leave a dry elegant trail.",
    },
    scentType: {
      sr: "Citrusni, začinski i vetiverski",
      en: "Citrus spicy vetiver",
    },
    dominantNotes: {
      sr: ["mandarina", "neroli", "muškatni oraščić", "vetiver"],
      en: ["mandarin", "neroli", "nutmeg", "vetiver"],
    },
    tags: {
      sr: ["Čist", "Prepoznatljiv", "Letnji"],
      en: ["Clean", "Signature", "Summer"],
    },
    whyChoose: {
      sr: "Ako želiš luksuznu, čistu i začinjenu svežinu sa elegantnim suvim završetkom.",
      en: "If you want luxurious clean spicy freshness with an elegant dry finish.",
    },
  },

  "French Avenue Ravine Ginger Extrait de Parfum": {
    miniTag: { sr: "🫚 Đumbir / Cvetni", en: "🫚 Ginger / Floral" },
    card: {
      sr: "Đumbir, limun i belo cveće u bogatom, svetlom letnjem mirisu.",
      en: "Ginger, lemon and white florals in a rich bright summer fragrance.",
    },
    modal: {
      sr: "Đumbir, limun i bergamot otvaraju miris energično, cvet narandže, magnolija, jasmin i ruža daju raskoš, a vanila, amber i sandalovina toplu dubinu.",
      en: "Ginger, lemon and bergamot open with energy, orange blossom, magnolia, jasmine and rose add opulence, while vanilla, amber and sandalwood bring warm depth.",
    },
    scentType: {
      sr: "Citrusni, cvetni i ambrast",
      en: "Citrus floral amber",
    },
    dominantNotes: {
      sr: ["đumbir", "limun", "cvet narandže", "vanila"],
      en: ["ginger", "lemon", "orange blossom", "vanilla"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Letnji", "Bogat"],
      en: ["Signature", "Summer", "Rich"],
    },
    whyChoose: {
      sr: "Ako želiš sofisticiran spoj blistavog đumbira, raskošnog cveća i tople baze.",
      en: "If you want a sophisticated blend of sparkling ginger, opulent florals and a warm base.",
    },
  },

  "Lattafa Khamrah Waha Eau de Parfum": {
    miniTag: { sr: "🥒 Yuzu / Krastavac", en: "🥒 Yuzu / Cucumber" },
    card: {
      sr: "Yuzu, krastavac i morska so. Sveže, slano, neočekivano.",
      en: "Yuzu, cucumber and sea salt in a modern woody-aromatic fragrance.",
    },
    modal: {
      sr: "Bergamot, kleka, yuzu i đumbir daju živahan početak, iris, krastavac, žalfija i morska so sveže srce, a Akigalawood, tonka, mošus i Ambrofix bogatu bazu.",
      en: "Bergamot, juniper, yuzu and ginger create a lively opening, iris, cucumber, sage and sea salt form a fresh heart, while Akigalawood, tonka, musk and Ambrofix build a rich base.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["yuzu", "krastavac", "morska so", "Akigalawood"],
      en: ["yuzu", "cucumber", "sea salt", "Akigalawood"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Bogat", "Večernji"],
      en: ["Signature", "Rich", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš neobičan i moderan miris koji spaja sveže zelene note i bogatu drvenastu bazu.",
      en: "If you want an unusual modern fragrance combining fresh green notes with a rich woody base.",
    },
  },

    "Rayhaan Nocturno Elixir Eau de Parfum": {
    miniTag: { sr: "🪵 Sandalovina / Amber", en: "🪵 Sandalwood / Amber" },
    card: {
      sr: "Sandalovina, amber i labdanum u glatkom tamnom drvenastom mirisu.",
      en: "Sandalwood, amber and labdanum in a smooth dark woody fragrance.",
    },
    modal: {
      sr: "Sandalovina daje gladak drvenasti početak, amber gradi toplo srce, a drvenaste note i labdanum ostavljaju dubok, smolast i elegantan trag.",
      en: "Sandalwood creates a smooth woody opening, amber builds a warm heart, while woody notes and labdanum leave a deep resinous elegant trail.",
    },
    scentType: {
      sr: "Drvenast, ambrast i smolast",
      en: "Woody amber resinous",
    },
    dominantNotes: {
      sr: ["sandalovina", "amber", "drvenaste note", "labdanum"],
      en: ["sandalwood", "amber", "woody notes", "labdanum"],
    },
    tags: {
      sr: ["Čist", "Prepoznatljiv", "Večernji"],
      en: ["Clean", "Signature", "Night"],
    },
    whyChoose: {
      sr: "Ako želiš uglađen, dubok i moderan drvenasto-ambrasti miris za svaki dan i izlazak.",
      en: "If you want a polished deep modern woody-amber fragrance for everyday wear and nights out.",
    },
  },

  "French Avenue Ravine Ice Extrait de Parfum": {
    miniTag: { sr: "🍋 Limun / Morska so", en: "🍋 Lemon / Sea Salt" },
    card: {
      sr: "Limun, morska so i mahovina u čistom osvežavajućem letnjem mirisu.",
      en: "Lemon, sea salt and moss in a clean refreshing summer fragrance.",
    },
    modal: {
      sr: "Limun i geranijum daju svetao početak, žalfija, lavanda i morska so aromatičnu svežinu, a mahovina, kedar i ambroksan čist drvenasti završetak.",
      en: "Lemon and geranium create a bright opening, sage, lavender and sea salt bring aromatic freshness, while moss, cedarwood and ambroxan provide a clean woody finish.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i morski",
      en: "Citrus aromatic marine",
    },
    dominantNotes: {
      sr: ["limun", "morska so", "mahovina", "ambroksan"],
      en: ["lemon", "sea salt", "moss", "ambroxan"],
    },
    tags: {
      sr: ["Letnji", "Čist", "Prepoznatljiv"],
      en: ["Summer", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš vedru morsko-citrusnu svežinu sa prirodnom zelenom i drvenastom dubinom.",
      en: "If you want bright marine-citrus freshness with natural green and woody depth.",
    },
  },

  "Paris Corner Mawj Moscow Mule Eau de Parfum": {
    miniTag: { sr: "🍹 Đumbir / Nana", en: "🍹 Ginger / Mint" },
    card: {
      sr: "Limun, đumbir i nana u energičnom mirisu inspirisanom koktelom.",
      en: "Lemon, ginger and mint in an energetic cocktail-inspired fragrance.",
    },
    modal: {
      sr: "Limun, đumbir i bergamot daju blistav početak, biljne note, čempres i nana hladno aromatično srce, a ozonske note, amber i mahovina prozračan završetak.",
      en: "Lemon, ginger and bergamot create a sparkling opening, herbal notes, cypress and mint form a cool aromatic heart, while ozonic notes, amber and moss provide an airy finish.",
    },
    scentType: {
      sr: "Citrusni, začinski i aromatičan",
      en: "Citrus spicy aromatic",
    },
    dominantNotes: {
      sr: ["limun", "đumbir", "nana", "čempres"],
      en: ["lemon", "ginger", "mint", "cypress"],
    },
    tags: {
      sr: ["Letnji", "Čist", "Prepoznatljiv"],
      en: ["Summer", "Clean", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš živahan i moderan letnji miris sa hladnim đumbirom i nanom.",
      en: "If you want a lively modern summer fragrance with cooling ginger and mint.",
    },
  },

  "My Geisha Jasmine in the Sun Extrait de Parfum": {
    miniTag: { sr: "☀️ Jasmin / Sunčan", en: "☀️ Jasmine / Solar" },
    card: {
      sr: "Jasmin, cvet narandže i vanila u blistavom sunčanom cvetnom mirisu.",
      en: "Jasmine, orange blossom and vanilla in a radiant solar floral fragrance.",
    },
    modal: {
      sr: "Bergamot, karanfilić i muškatna žalfija daju svetao začinski početak, jasmin, cvet narandže i ilang-ilang raskošno cvetno srce, a amber, pačuli, kedar i vanila toplu dubinu.",
      en: "Bergamot, clove and clary sage create a bright spicy opening, jasmine, orange blossom and ylang-ylang form a lush floral heart, while amber, patchouli, cedarwood and vanilla add warm depth.",
    },
    scentType: {
      sr: "Cvetni, začinski i ambrast",
      en: "Floral spicy amber",
    },
    dominantNotes: {
      sr: ["jasmin", "cvet narandže", "ilang-ilang", "vanila"],
      en: ["jasmine", "orange blossom", "ylang-ylang", "vanilla"],
    },
    tags: {
      sr: ["Letnji", "Nežan", "Prepoznatljiv"],
      en: ["Summer", "Soft", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš blistav, ženstven i topao cvetni parfem sa jasminom u glavnoj ulozi.",
      en: "If you want a radiant feminine warm floral fragrance with jasmine at its center.",
    },
  },

  "Essential Parfums Nice Bergamote Eau de Parfum": {
    miniTag: { sr: "🍋 Bergamot / Cvetni", en: "🍋 Bergamot / Floral" },
    card: {
      sr: "Bergamot, ilang-ilang i kedar u prirodnom svetlom citrusnom mirisu.",
      en: "Bergamot, ylang-ylang and cedarwood with a bright natural lift.",
    },
    modal: {
      sr: "Bergamot otvara miris blistavo i sočno, jasmin, ilang-ilang i ruža grade elegantno cvetno srce, a kedar i tonka ostavljaju mekan i topao trag.",
      en: "Bergamot opens brightly and juicily, jasmine, ylang-ylang and rose form an elegant floral heart, while cedarwood and tonka bean leave a soft warm trail.",
    },
    scentType: {
      sr: "Citrusni, cvetni i drvenast",
      en: "Citrus floral woody",
    },
    dominantNotes: {
      sr: ["bergamot", "jasmin", "ilang-ilang", "kedar"],
      en: ["bergamot", "jasmine", "ylang-ylang", "cedarwood"],
    },
    tags: {
      sr: ["Čist", "Letnji", "Prepoznatljiv"],
      en: ["Clean", "Summer", "Signature"],
    },
    whyChoose: {
      sr: "Ako želiš prirodnu i profinjenu citrusnu svežinu sa mekim cvetnim karakterom.",
      en: "If you want natural refined citrus freshness with a soft floral character.",
    },
  },

  "Essential Parfums Orange X Santal Eau de Parfum": {
    miniTag: { sr: "🍊 Gorka narandža / Sandalovina", en: "🍊 Bitter Orange / Sandalwood" },
    card: {
      sr: "Gorka narandža i bosiljak preko suve, kremaste sandalovine.",
      en: "Bitter orange, basil and sandalwood in a modern citrus-woody fragrance.",
    },
    modal: {
      sr: "Gorka i slatka narandža daju sočan početak, bosiljak i čempres aromatičnu zelenu sredinu, a hrastova mahovina i sandalovina mekanu drvenastu dubinu.",
      en: "Bitter and sweet orange create a juicy opening, basil and cypress bring an aromatic green heart, while oakmoss and sandalwood add soft woody depth.",
    },
    scentType: {
      sr: "Citrusni, aromatičan i drvenast",
      en: "Citrus aromatic woody",
    },
    dominantNotes: {
      sr: ["gorka narandža", "bosiljak", "sandalovina", "hrastova mahovina"],
      en: ["bitter orange", "basil", "sandalwood", "oakmoss"],
    },
    tags: {
      sr: ["Prepoznatljiv", "Čist", "Nežan"],
      en: ["Signature", "Clean", "Soft"],
    },
    whyChoose: {
      sr: "Ako želiš moderan niche citrus sa zelenom svežinom i kremastom drvenastom bazom.",
      en: "If you want a modern niche citrus with green freshness and a creamy woody base.",
    },
  },

  "Armaf Club de Nuit Intense Overdose Eau de Parfum": {
  miniTag: {
    sr: "💎 Voćni / Intenzivan",
    en: "💎 Fruity / Intense"
  },

  card: {
    sr: "Sočan ananas, mahovina i amber u snažnom modernom profilu.",
    en: "Juicy pineapple, oakmoss and amber in a bold modern profile."
  },

  modal: {
    sr: "Ananas, citrusi i kristalna svežina prelaze u šljivu, mahovinu i toplu amber-tonka bazu.",
    en: "Pineapple, citrus and crystalline freshness settle into plum, oakmoss and a warm amber-tonka base."
  },

  scentType: {
    sr: "Voćni drvenasto-amber",
    en: "Fruity woody amber"
  },

  dominantNotes: {
    sr: ["ananas", "hrastova mahovina", "šljiva", "tonka"],
    en: ["pineapple", "oakmoss", "plum", "tonka bean"]
  },

  tags: {
    sr: ["Intenzivan", "Signature", "Moderan"],
    en: ["Intense", "Signature", "Modern"]
  },

  whyChoose: {
    sr: "Ako želiš snažan, upečatljiv i dugotrajan miris sa potpisom.",
    en: "If you want a bold, distinctive and long-lasting signature scent."
  }
},

"Gisada Luxury Collection Royal Parfum": {
  miniTag: {
    sr: "👑 Koža / Cvetni",
    en: "👑 Leather / Floral"
  },

  card: {
    sr: "Koža, jasmin i oud u raskošnom uniseks spoju.",
    en: "Leather, jasmine and oud in a luxurious unisex blend."
  },

  modal: {
    sr: "Koža i jasmin otvaraju miris elegantno, dok ljubičica, frezija i oud prelaze u toplu bazu ambera, mošusa i vanile.",
    en: "Leather and jasmine open elegantly, while violet, freesia and oud settle into a warm amber, musk and vanilla base."
  },

  scentType: {
    sr: "Cvetno-kožni amber",
    en: "Floral leather amber"
  },

  dominantNotes: {
    sr: ["koža", "jasmin", "oud", "mošus"],
    en: ["leather", "jasmine", "oud", "musk"]
  },

  tags: {
    sr: ["Luksuzan", "Elegantan", "Uniseks"],
    en: ["Luxury", "Elegant", "Unisex"]
  },

  whyChoose: {
    sr: "Ako želiš sofisticiran i upečatljiv luksuzni miris.",
    en: "If you want a sophisticated and distinctive luxury fragrance."
  }
},

"Swiss Arabian Musk 01 Extrait de Parfum": {
  miniTag: {
    sr: "🤍 Mošus / Čist",
    en: "🤍 Musk / Clean"
  },

  card: {
    sr: "Mošus, bergamot i beli cvetovi u nežnom luksuznom spoju.",
    en: "Musk, bergamot and white florals in a soft luxurious blend."
  },

  modal: {
    sr: "Bergamot, roze biber i elemi vode ka belim cvetovima i mošusu, uz kremastu bazu vanile, tonke i sandalovine.",
    en: "Bergamot, pink pepper and elemi lead into white florals and musk, with a creamy vanilla, tonka and sandalwood base."
  },

  scentType: {
    sr: "Cvetno-mošusni",
    en: "Floral musky"
  },

  dominantNotes: {
    sr: ["mošus", "bergamot", "cvet narandže", "sandalovina"],
    en: ["musk", "bergamot", "orange blossom", "sandalwood"]
  },

  tags: {
    sr: ["Čist", "Nežan", "Uniseks"],
    en: ["Clean", "Soft", "Unisex"]
  },

  whyChoose: {
    sr: "Ako voliš čist, mekan i sofisticiran mošusni miris.",
    en: "If you enjoy a clean, soft and sophisticated musky fragrance."
  }
},

"Afnan Turathi Electric Eau de Parfum": {
  miniTag: {
    sr: "⚡ Voćni / Svež",
    en: "⚡ Fruity / Fresh"
  },

  card: {
    sr: "Sočna kruška i citrusi u blistavom modernom profilu.",
    en: "Juicy pear and citrus in a bright modern profile."
  },

  modal: {
    sr: "Kruška, grejpfrut i mandarina prelaze u jabuku i cvet narandže, uz čistu mošusno-amber bazu.",
    en: "Pear, grapefruit and mandarin lead into apple and orange blossom over a clean musky-amber base."
  },

  scentType: {
    sr: "Voćno-cvetni mošusni",
    en: "Fruity floral musky"
  },

  dominantNotes: {
    sr: ["kruška", "grejpfrut", "jabuka", "mošus"],
    en: ["pear", "grapefruit", "apple", "musk"]
  },

  tags: {
    sr: ["Svež", "Letnji", "Moderan"],
    en: ["Fresh", "Summer", "Modern"]
  },

  whyChoose: {
    sr: "Ako želiš blistav, moderan i lako nosiv letnji miris.",
    en: "If you want a bright, modern and easy-to-wear summer scent."
  }
},

"Jil Sander Sun Eau de Toilette": {
  miniTag: {
    sr: "☀️ Sunčan / Kremast",
    en: "☀️ Solar / Creamy"
  },

  card: {
    sr: "Sunčano cveće, vanila i sandalovina u toplom klasiku.",
    en: "Solar florals, vanilla and sandalwood in a warm classic."
  },

  modal: {
    sr: "Citrusi i cvet narandže prelaze u bogato cvetno srce, uz toplu bazu vanile, ambera i sandalovine.",
    en: "Citrus and orange blossom lead into a rich floral heart over warm vanilla, amber and sandalwood."
  },

  scentType: {
    sr: "Topli cvetno-amberni",
    en: "Warm floral amber"
  },

  dominantNotes: {
    sr: ["cvet narandže", "ylang-ylang", "vanila", "sandalovina"],
    en: ["orange blossom", "ylang-ylang", "vanilla", "sandalwood"]
  },

  tags: {
    sr: ["Topao", "Cvetni", "Kremast"],
    en: ["Warm", "Floral", "Creamy"]
  },

  whyChoose: {
    sr: "Ako voliš tople, kremaste i prepoznatljive mirisne klasike.",
    en: "If you enjoy warm, creamy and distinctive fragrance classics."
  }
},

"Mancera Cosmic Pepper Eau de Parfum": {
  miniTag: {
    sr: "🌶️ Biber / Drvenast",
    en: "🌶️ Pepper / Woody"
  },

  card: {
    sr: "Biber, citrusi i oud u energičnom nišnom spoju.",
    en: "Pepper, citrus and oud in an energetic niche blend."
  },

  modal: {
    sr: "Roze i crni biber sa citrusima vode ka ruži i oudu, uz toplu bazu tonke, ambera i labdanuma.",
    en: "Pink and black pepper with citrus lead into rose and oud over a warm tonka, amber and labdanum base."
  },

  scentType: {
    sr: "Začinski drvenasto-amberni",
    en: "Spicy woody amber"
  },

  dominantNotes: {
    sr: ["crni biber", "limun", "oud", "tonka"],
    en: ["black pepper", "lemon", "oud", "tonka bean"]
  },

  tags: {
    sr: ["Začinski", "Drvenast", "Upečatljiv"],
    en: ["Spicy", "Woody", "Bold"]
  },

  whyChoose: {
    sr: "Ako želiš energičan i sofisticiran nišni miris sa izraženim biberom.",
    en: "If you want an energetic sophisticated niche scent with a pronounced pepper character."
  }
},

"Thomas Kosmala No. 4 Après l'Amour Eau de Parfum": {
  miniTag: {
    sr: "🟠 Amber / Mošus",
    en: "🟠 Amber / Musk"
  },

  card: {
    sr: "Citrusi, suvo drvo i mošus u senzualnom modernom spoju.",
    en: "Citrus, dry woods and musk in a sensual modern blend."
  },

  modal: {
    sr: "Gorka narandža i korica limuna otvaraju miris sveže, pre prelaska u aromatično srce i toplu bazu suvog drveta, ambera i mošusa.",
    en: "Bitter orange and lemon zest open brightly before settling into an aromatic heart and a warm base of dry woods, amber and musk."
  },

  scentType: {
    sr: "Aromatični drvenasto-amberni",
    en: "Aromatic woody amber"
  },

  dominantNotes: {
    sr: ["gorka narandža", "suvo drvo", "amber", "mošus"],
    en: ["bitter orange", "dry woods", "amber", "musk"]
  },

  tags: {
    sr: ["Moderan", "Senzualan", "Upečatljiv"],
    en: ["Modern", "Sensual", "Distinctive"]
  },

  whyChoose: {
    sr: "Ako želiš minimalistički, moderan miris sa snažnim mošusno-ambernim potpisom.",
    en: "If you want a minimalist modern scent with a strong musky-amber signature."
  }
},

"Thomas Kosmala No. 1 Tonic Blanc Eau de Parfum": {
  miniTag: {
    sr: "🍊 Neroli / Citrus",
    en: "🍊 Neroli / Citrus"
  },

  card: {
    sr: "Neroli, citrusi i čiste drvene note u elegantnom svežem spoju.",
    en: "Neroli, citrus and clean woods in an elegant fresh blend."
  },

  modal: {
    sr: "Bergamot, mandarina, narandža i neroli prelaze u blago cvetno srce, uz suvu bazu mahovine, sandalovine, kedra i mošusa.",
    en: "Bergamot, mandarin, orange and neroli lead into a soft floral heart over a dry base of oakmoss, sandalwood, cedar and musk."
  },

  scentType: {
    sr: "Citrusno-aromatični",
    en: "Citrus aromatic"
  },

  dominantNotes: {
    sr: ["neroli", "bergamot", "cvet narandže", "sandalovina"],
    en: ["neroli", "bergamot", "orange blossom", "sandalwood"]
  },

  tags: {
    sr: ["Svež", "Čist", "Elegantan"],
    en: ["Fresh", "Clean", "Elegant"]
  },

  whyChoose: {
    sr: "Ako voliš prirodnu citrusnu svežinu, neroli i čist mediteranski karakter.",
    en: "If you enjoy natural citrus freshness, neroli and a clean Mediterranean character."
  }
},

"Narciso Rodriguez for Him Bleu Noir Eau de Toilette Extreme": {
  miniTag: {
    sr: "❄️ Svež / Mošusni",
    en: "❄️ Fresh / Musky"
  },

  card: {
    sr: "Ledeni citrusi, zeleni bosiljak i tamne drvene note.",
    en: "Icy citrus, green basil and dark woods."
  },

  modal: {
    sr: "Zelena mandarina, bosiljak i hladni citrusi vode ka čistom mošusu, uz tamnu bazu kedra, ebanovine i labdanuma.",
    en: "Green mandarin, basil and icy citrus lead into clean musk over a dark cedar, ebony and labdanum base."
  },

  scentType: {
    sr: "Sveži drvenasto-mošusni",
    en: "Fresh woody musky"
  },

  dominantNotes: {
    sr: ["zelena mandarina", "bosiljak", "mošus", "ebonovina"],
    en: ["green mandarin", "basil", "musk", "ebony"]
  },

  tags: {
    sr: ["Svež", "Čist", "Moderan"],
    en: ["Fresh", "Clean", "Modern"]
  },

  whyChoose: {
    sr: "Ako želiš hladan, čist i elegantan miris sa tamnom drvenastom bazom.",
    en: "If you want a cool, clean and elegant fragrance with a dark woody base."
  }
},

  "Thomas Kosmala No. 8 Tonic Vert Eau de Parfum": {
    miniTag: {
      sr: "🌿 Zeleni / Citrusni",
      en: "🌿 Green / Citrus"
    },
    card: {
      sr: "Citrusi, hladna menta i vetiver u čistom zelenom mirisu.",
      en: "Citrus, cool mint and vetiver in a clean green aromatic fragrance."
    },
    modal: {
      sr: "Bergamot, limun, mandarina i limeta prelaze u hladnu mentu, geranijum i pomelo, dok vetiver, mošus i hrastova mahovina ostavljaju suv, čist i zelen trag.",
      en: "Bergamot, lemon, mandarin and lime lead into cool mint, geranium and pomelo, while vetiver, musk and oakmoss leave a dry, clean and green trail."
    },
    scentType: {
      sr: "Citrusno-zeleni aromatični",
      en: "Citrus green aromatic"
    },
    dominantNotes: {
      sr: ["bergamot", "menta", "vetiver", "hrastova mahovina"],
      en: ["bergamot", "mint", "vetiver", "oakmoss"]
    },
    tags: {
      sr: ["Svež", "Čist", "Zelen"],
      en: ["Fresh", "Clean", "Green"]
    },
    whyChoose: {
      sr: "Ako želiš hladan, suv i čist zeleni parfem za tople dane.",
      en: "If you want a cool, dry and clean green fragrance for warm days."
    }
  },

  "Christian Dior Sauvage Eau de Parfum": {
    "miniTag": {
      "en": "🌶️ Fresh / Spicy",
      "sr": "🌶️ Svež / Začinski"},
    "card": {
      "en": "Bergamot, spice and warm vanilla in a modern signature.",
      "sr": "Bergamot, začini i topla vanila u modernom potpisu."
    },
    "modal": {
      "en": "Fresh bergamot and aromatic spice move into lavender, warm vanilla and ambroxan, leaving a bold and distinctive trail.",
      "sr": "Svež bergamot i aromatični začini prelaze u lavandu, toplu vanilu i ambroksan, ostavljajući snažan i prepoznatljiv trag."
    },
    "scentType": {
      "en": "Aromatic amber citrus fragrance",
      "sr": "Aromatično-ambarni citrusni miris"
    },
    "dominantNotes": {
      "sr": [
        "Bergamot",
        "Lavanda",
        "Vanila",
        "Ambroksan"
      ],
      "en": [
        "Bergamot",
        "Lavender",
        "Vanilla",
        "Ambroxan"
      ]
    },
    "tags": {
      "sr": [
        "Svež",
        "Začinski",
        "Muževan"
      ],
      "en": [
        "Fresh",
        "Spicy",
        "Masculine"
      ]
    },
    "whyChoose": {
      "en": "If you want a bold, recognizable and highly versatile fragrance.",
      "sr": "Ako želiš snažan, prepoznatljiv i veoma svestran parfem."
    }
  },

  "Nishane Hacivat X Extrait de Parfum": {
    "miniTag": {
      "en": "🍍 Citrus / Woody",
      "sr": "🍍 Citrusni / Drvenast"
    },
    "card": {
      "en": "Pineapple, bergamot and vetiver in a clean chypre signature.",
      "sr": "Ananas, bergamot i vetiver u čistom chypre potpisu."
    },
    "modal": {
      "en": "Juicy pineapple and bergamot open with pink pepper, while lime and orange blossom lead into a dry, elegant base of cedar, patchouli and vetiver.",
      "sr": "Sočan ananas i bergamot otvaraju miris uz ružičasti biber, dok limeta i cvet narandže vode ka suvoj, elegantnoj bazi kedra, pačulija i vetivera."
    },
    "scentType": {
      "en": "Citrus chypre woody extrait",
      "sr": "Citrusni chypre drvenasti extrait"
    },
    "dominantNotes": {
      "sr": [
        "Ananas",
        "Bergamot",
        "Vetiver",
        "Kedar"
      ],
      "en": [
        "Pineapple",
        "Bergamot",
        "Vetiver",
        "Cedar"
      ]
    },
    "tags": {
      "sr": [
        "Citrusni",
        "Drvenasti",
        "Elegantni"
      ],
      "en": [
        "Citrusy",
        "Woody",
        "Elegant"
      ]
    },
    "whyChoose": {
      "en": "For a distinctive, clean niche scent with strong presence and excellent versatility.",
      "sr": "Za upečatljiv, čist niche miris sa ozbiljnim prisustvom i odličnom svestranošću."
    }
  },

  "Yves Saint Laurent La Nuit de L'Homme Eau de Toilette": {
    "miniTag": {
      "en": "🌶️ Spicy / Woody",
      "sr": "🌶️ Začinski / Drvenast"
    },
    "card": {
      "en": "Cardamom, lavender and cedar in a warm, elegant evening scent.",
      "sr": "Kardamom, lavanda i kedar u toplom večernjem mirisu."
    },
    "modal": {
      "en": "Cardamom and bergamot open the scent with lavender, black pepper and cedar. Tonka bean and vetiver create a warm, smooth finish made for elegant evenings.",
      "sr": "Kardamom i bergamot otvaraju miris, uz lavandu, crni biber i kedar. Tonka i vetiver daju toplu, glatku završnicu za elegantne večernje prilike."
    },
    "scentType": {
      "en": "Spicy aromatic woody",
      "sr": "Začinski aromatični drvenasti"
    },
    "dominantNotes": {
      "sr": [
        "Kardamom",
        "Lavanda",
        "Kedar",
        "Tonka"
      ],
      "en": [
        "Cardamom",
        "Lavender",
        "Cedarwood",
        "Tonka Bean"
      ]
    },
    "tags": {
      "sr": [
        "Začinski",
        "Aromatičan",
        "Drvenast"
      ],
      "en": [
        "Spicy",
        "Aromatic",
        "Woody"
      ]
    },
    "whyChoose": {
      "en": "For dates and evenings when you want a warm, elegant and quietly seductive scent.",
      "sr": "Za dejt i veče kada želiš topao, elegantan i nenametljivo zavodljiv miris."
    }
  },

  "Tom Ford Ombré Leather Parfum": {
    "miniTag": {
      "en": "🖤 Leather / Floral",
      "sr": "🖤 Kožni / Cvetni"
    },
    "card": {
      "en": "Leather, violet and iris in a dark, elegant scent.",
      "sr": "Koža, ljubičica i iris u tamnom elegantnom mirisu."
    },
    "modal": {
      "en": "Violet leaf and cedar open green and dry. Jasmine sambac and orris soften the leather, while tobacco and woody notes build a deep, elegant trail.",
      "sr": "List ljubičice i kedar otvaraju miris zeleno i suvo. Sambak jasmin i iris omekšavaju kožu, dok duvan i drvene note grade dubok, elegantan trag."
    },
    "scentType": {
      "en": "Leather floral woody",
      "sr": "Kožni cvetni drvenasti"
    },
    "dominantNotes": {
      "sr": [
        "Koža",
        "List ljubičice",
        "Iris",
        "Kedar"
      ],
      "en": [
        "Leather",
        "Violet Leaf",
        "Orris",
        "Cedarwood"
      ]
    },
    "tags": {
      "sr": [
        "Kožni",
        "Drvenast",
        "Elegantan"
      ],
      "en": [
        "Leather",
        "Woody",
        "Elegant"
      ]
    },
    "whyChoose": {
      "en": "For a distinctive leather scent that balances dark elegance with a clean floral contrast.",
      "sr": "Za upečatljiv kožni parfem koji spaja tamnu eleganciju sa čistim cvetnim kontrastom."
    }
  },

  "Arabiyat Prestige Al Noor Eau De Parfum": {
    "miniTag": {
      "en": "🌶️ Spicy / Warm",
      "sr": "🌶️ Začinski / Topao"
    },
    "card": {
      "en": "Cardamom, fig and iris over a leathery base. Warm and elegant.",
      "sr": "Kardamom, smokva i iris na koži. Topao i elegantan."
    },
    "modal": {
      "en": "Al Noor opens with cardamom and saffron. Fig, iris and vetiver add depth, while leather, tonka, vanilla and patchouli create a warm, dark drydown.",
      "sr": "Al Noor otvara kardamomom i šafranom. Smokva, iris i vetiver daju dubinu, dok koža, tonka, vanila i pačuli grade topao, taman završetak."
    },
    "scentType": {
      "en": "Spicy woody",
      "sr": "Začinski drvenasti"
    },
    "dominantNotes": {
      "sr": [
        "Kardamom",
        "Smokva",
        "Iris",
        "Koža"
      ],
      "en": [
        "Cardamom",
        "Fig",
        "Iris",
        "Leather"
      ]
    },
    "tags": {
      "sr": [
        "Začinski",
        "topao",
        "elegantan"
      ],
      "en": [
        "Spicy",
        "warm",
        "elegant"
      ]
    },
    "whyChoose": {
      "en": "For fans of darker spicy scents with fig, leather and refined sweetness.",
      "sr": "Za ljubitelje tamnijih začinskih mirisa sa smokvom, kožom i elegantnom slatkoćom."
    }
  },

  "Rayhaan Elixir Eau de Parfum": {
    "miniTag": {
      "en": "🍦 Vanilla / Aromatic",
      "sr": "🍦 Vanilast / Aromatičan"},
    "card": {
      "en": "Warm vanilla, lavender and tonka for nights that call for more.",
      "sr": "Topla vanila, lavanda i tonka za večeri koje traže malo više."
    },
    "modal": {
      "en": "Mint and bergamot open fresh, lavender and benzoin add warmth, while vanilla and tonka finish rich, sweet and distinctly seductive.",
      "sr": "Mint i bergamot otvaraju sveže, lavanda i benzoin brzo donose toplinu, a vanila i tonka završavaju priču bogato, slatko i vrlo zavodljivo."
    },
    "scentType": {
      "en": "Aromatic amber with vanilla",
      "sr": "Aromatični amber sa vanilom"
    },
    "dominantNotes": {
      "sr": [
        "Vanila",
        "Lavanda",
        "Benzoin",
        "Tonka"
      ],
      "en": [
        "Vanilla",
        "Lavender",
        "Benzoin",
        "Tonka Bean"
      ]
    },
    "tags": {
      "sr": [
        "Sladak",
        "Topao",
        "Večernji"
      ],
      "en": [
        "Sweet",
        "Warm",
        "Evening"
      ]
    },
    "whyChoose": {
      "en": "An easy choice if you like sweet evening scents built around vanilla.",
      "sr": "Ako volite slatke večernje mirise sa vanilom, ovo je vrlo lak izbor."
    }
  },

  "Jil Sander Sun Men Eau de Toilette": {
    "miniTag": {
      "en": "☀️ Fresh / Aromatic",
      "sr": "☀️ Svež / Aromatičan"
    },
    "card": {
      "en": "Bergamot, rosemary and spice in a clean summer classic.",
      "sr": "Bergamot, ruzmarin i začini u čistom letnjem klasiku."
    },
    "modal": {
      "en": "Bergamot and rosemary open fresh, cardamom and nutmeg add warmth, while musk and sandalwood keep the drydown clean and soft.",
      "sr": "Bergamot i ruzmarin otvaraju sveže, kardamom i muškatni oraščić dodaju toplinu, dok mošus i sandalovina ostaju čisti i meki."
    },
    "scentType": {
      "en": "Fresh citrus spicy",
      "sr": "Sveži citrusno-začinski"
    },
    "dominantNotes": {
      "sr": [
        "Bergamot",
        "Ruzmarin",
        "Kardamom",
        "Sandalovina"
      ],
      "en": [
        "Bergamot",
        "Rosemary",
        "Cardamom",
        "Sandalwood"
      ]
    },
    "tags": {
      "sr": [
        "Svež",
        "Aromatičan",
        "Letnji"
      ],
      "en": [
        "Fresh",
        "Aromatic",
        "Summer"
      ]
    },
    "whyChoose": {
      "en": "If you want a light, clean and understated summer fragrance for everyday wear.",
      "sr": "Ako želite lagan, čist i nenametljiv letnji miris za svaki dan."
    }
  },

  "My Geisha Unseen Extrait de Parfum": {
    "miniTag": {
      "en": "🥃 Cognac / Gourmand",
      "sr": "🥃 Konjak / Gurmanski"
    },
    "card": {
      "en": "Cognac, caramel and tobacco over vanilla, tonka and dark oud.",
      "sr": "Konjak, karamela i duvan preko vanile, tonke i tamnog ouda."
    },
    "modal": {
      "en": "Cognac, caramel and tobacco open richly; dates, praline and tuberose add body, while vanilla, tonka, oud, myrrh and benzoin form a deep warm base.",
      "sr": "Konjak, karamela i duvan otvaraju bogato; urme, pralina i tuberoza daju punoću, dok vanila, tonka, oud, smirna i benzoin grade duboku toplu bazu."
    },
    "scentType": {
      "en": "Oriental gourmand woody",
      "sr": "Orijentalni, gurmanski i drvenast"
    },
    "dominantNotes": {
      "sr": [
        "konjak",
        "vanila",
        "duvan",
        "oud"
      ],
      "en": [
        "cognac",
        "vanilla",
        "tobacco",
        "oud"
      ]
    },
    "tags": {
      "sr": [
        "Bogat",
        "Dejt",
        "Prepoznatljiv"
      ],
      "en": [
        "Rich",
        "Date Night",
        "Signature"
      ]
    },
    "whyChoose": {
      "en": "If you want a dark, sweet and opulent unisex gourmand with tobacco, vanilla and oud.",
      "sr": "Ako želiš taman, sladak i raskošan uniseks gourmand sa duvanom, vanilom i oudom."
    }
  },

  "Nishane Hundred Silent Ways X Extrait de Parfum": {
    "miniTag": {
      "en": "🍑 Peach / Vanilla / Leather",
      "sr": "🍑 Breskva / Vanila / Koža"
    },
    "card": {
      "en": "Peach and white florals melt into creamy vanilla and leather.",
      "sr": "Breskva i belo cveće prelaze u kremastu vanilu i kožu."
    },
    "modal": {
      "en": "A rich floral scent with juicy peach, creamy vanilla and leather for a deeper, more elegant finish.",
      "sr": "Bogat cvetni miris sa sočnom breskvom, kremastom vanilom i kožom koja mu daje dublji, elegantniji završetak."
    },
    "scentType": {
      "en": "Floral, sweet and leathery",
      "sr": "Cvetni, slatki i kožni"
    },
    "dominantNotes": {
      "sr": [
        "Breskva",
        "tuberoza",
        "vanila",
        "koža"
      ],
      "en": [
        "Peach",
        "tuberose",
        "vanilla",
        "leather"
      ]
    },
    "tags": {
      "sr": [
        "cvetno",
        "kremasto",
        "elegantno"
      ],
      "en": [
        "floral",
        "creamy",
        "elegant"
      ]
    },
    "whyChoose": {
      "en": "For those who enjoy rich florals with vanilla and an elegant leathery finish.",
      "sr": "Za one koji vole bogate cvetne mirise sa vanilom i elegantnim kožnim završetkom."
    }
  },

  "French Avenue Spectre Ghost Eau de Parfum": {
    "miniTag": {
      "en": "🌶️ Spicy / Vanilla",
      "sr": "🌶️ Začinski / Vanilast"
    },
    "card": {
      "en": "Ginger, cardamom and creamy vanilla in a warm, spicy scent.",
      "sr": "Đumbir, kardamom i kremasta vanila u toplom, začinskom mirisu."
    },
    "modal": {
      "en": "Fresh ginger and bergamot lead into spicy cardamom and blackcurrant. Vanilla, sandalwood and benzoin create a warm, creamy finish.",
      "sr": "Svež đumbir i bergamot otvaraju miris, dok kardamom i crna ribizla donose začinsku dubinu. Vanila, sandalovina i benzoin daju topao, kremast trag."
    },
    "scentType": {
      "en": "Warm spicy woody amber",
      "sr": "Topli začinsko-drvenasti amber"
    },
    "dominantNotes": {
      "sr": [
        "đumbir",
        "kardamom",
        "vanila",
        "sandalovina"
      ],
      "en": [
        "ginger",
        "cardamom",
        "vanilla",
        "sandalwood"
      ]
    },
    "tags": {
      "sr": [
        "Začinski",
        "Topao",
        "Kremast"
      ],
      "en": [
        "Spicy",
        "Warm",
        "Creamy"
      ]
    },
    "whyChoose": {
      "en": "For lovers of lively ginger, creamy vanilla and a warm woody finish.",
      "sr": "Za ljubitelje živahnog đumbira, kremaste vanile i toplog drvenastog završetka."
    }
  },

  "Maison Alhambra Jean Lowe Verde Aura Eau de Parfum": {
    "miniTag": {
      "en": "🌿 Green / Citrus",
      "sr": "🌿 Zeleni / Citrusni"
    },
    "card": {
      "en": "Citrus, mint and basil in a fresh green scent with fig.",
      "sr": "Citrusi, menta i bosiljak u svežem zelenom mirisu sa smokvom."
    },
    "modal": {
      "en": "Lemon, citron and mint open brightly, while basil and carrot seed add a green, herbal twist. Fig and ambrette leave a soft, gently sweet trail.",
      "sr": "Citron i menta otvaraju sveže, dok bosiljak i seme šargarepe donose biljnu dubinu. Smokva i ambreta ostavljaju mekan, blago sladak trag."
    },
    "scentType": {
      "en": "Green citrus aromatic",
      "sr": "Zeleni citrusno-aromatični"
    },
    "dominantNotes": {
      "sr": [
        "citron",
        "menta",
        "bosiljak",
        "smokva"
      ],
      "en": [
        "citron",
        "mint",
        "basil",
        "fig"
      ]
    },
    "tags": {
      "sr": [
        "Svež",
        "Zelen",
        "Aromatičan"
      ],
      "en": [
        "Fresh",
        "Green",
        "Aromatic"
      ]
    },
    "whyChoose": {
      "en": "For lovers of bright citrus, green herbal notes and a distinctive, softly fruity drydown.",
      "sr": "Za ljubitelje citrusne svežine, zelenih biljnih nota i neobične, nežno voćne završnice."
    }
  },

  "French Avenue Imperial Ocean Eau de Parfum": {
    "miniTag": {
      "en": "🌊 Marine / Salty",
      "sr": "🌊 Morski / Slankast"
    },
    "card": {
      "en": "Sea salt, ginger and vetiver in a fresh, mineral scent.",
      "sr": "Morska so, đumbir i vetiver u svežem, mineralnom mirisu."
    },
    "modal": {
      "en": "Bergamot, ginger and sea salt open crisp and fresh. Seaweed and vetiver add green depth, while ambergris and cedarwood leave a dry, woody trail.",
      "sr": "Bergamot, đumbir i morska so otvaraju sveže i slankasto. Morska trava i vetiver donose zelenu dubinu, dok ambergris i kedar daju suv, drvenast trag."
    },
    "scentType": {
      "en": "Marine woody aromatic",
      "sr": "Morski drvenasto-aromatični"
    },
    "dominantNotes": {
      "sr": [
        "morska so",
        "đumbir",
        "vetiver",
        "ambergris"
      ],
      "en": [
        "sea salt",
        "ginger",
        "vetiver",
        "ambergris"
      ]
    },
    "tags": {
      "sr": [
        "Morski",
        "Svež",
        "Mineralan"
      ],
      "en": [
        "Marine",
        "Fresh",
        "Mineral"
      ]
    },
    "whyChoose": {
      "en": "For lovers of salty marine freshness and dry woods, without unnecessary sweetness.",
      "sr": "Za ljubitelje morske svežine, slankastih akorda i suvog drveta, bez suvišne slatkoće."
    }
  },

  "Armaf Club de Nuit Milestone Eau de Parfum": {
    "miniTag": {
      "en": "🌊 Marine / Fruity",
      "sr": "🌊 Morski / Voćni"
    },
    "card": {
      "en": "Marine freshness, red fruits and soft woods in a salty blend.",
      "sr": "Morska svežina, crveno voće i meko drvo u slankastom spoju."
    },
    "modal": {
      "en": "Bergamot, red fruits and marine notes open fresh and salty. Violet and sandalwood add softness, while vetiver, musk and ambroxan leave a clean trail.",
      "sr": "Bergamot, crveno voće i morski akordi otvaraju sveže i slankasto. Ljubičica i sandalovina daju mekoću, a vetiver, mošus i ambroksan čist završetak."
    },
    "scentType": {
      "en": "Fruity marine woody musk",
      "sr": "Voćno-morski drvenasto-mošusni"
    },
    "dominantNotes": {
      "sr": [
        "morski akordi",
        "crveno voće",
        "sandalovina",
        "mošus"
      ],
      "en": [
        "marine notes",
        "red fruits",
        "sandalwood",
        "musk"
      ]
    },
    "tags": {
      "sr": [
        "Morski",
        "Voćni",
        "Elegantan"
      ],
      "en": [
        "Marine",
        "Fruity",
        "Elegant"
      ]
    },
    "whyChoose": {
      "en": "For lovers of salty marine freshness, juicy fruit and an elegant musky finish.",
      "sr": "Za ljubitelje slankaste morske svežine, sočnog voća i elegantnog mošusnog završetka."
    }
  },

  "Armaf Club de Nuit Maleka Eau de Parfum": {
    "miniTag": {
      "en": "🌸 Fruity / Powdery",
      "sr": "🌸 Voćni / Puderast"
    },
    "card": {
      "en": "Juicy lychee, powdery orris and praline in a soft elegant scent.",
      "sr": "Sočan liči, puderasti iris i praline u mekom, elegantnom mirisu."
    },
    "modal": {
      "en": "Lychee, bergamot and pink pepper open bright and fruity. Powdery orris adds elegance, while praline, sandalwood and ambroxan give a warm, creamy finish.",
      "sr": "Liči, bergamot i roze biber otvaraju voćno i sveže. Puderasti iris donosi eleganciju, a praline, sandalovina i ambroksan topao, kremast završetak."
    },
    "scentType": {
      "en": "Fruity floral powdery",
      "sr": "Voćno-cvetni puderasti"
    },
    "dominantNotes": {
      "sr": [
        "liči",
        "iris",
        "praline",
        "sandalovina"
      ],
      "en": [
        "lychee",
        "orris",
        "praline",
        "sandalwood"
      ]
    },
    "tags": {
      "sr": [
        "Voćni",
        "Puderast",
        "Elegantan"
      ],
      "en": [
        "Fruity",
        "Powdery",
        "Elegant"
      ]
    },
    "whyChoose": {
      "en": "For those who love juicy fruit, soft powdery orris and warm creamy sweetness.",
      "sr": "Za one koji vole sočno voće, nežan puderasti iris i toplu, kremastu slatkoću."
    }
  },

  "Giorgio Armani I Will Eau de Parfum": {
    "miniTag": {
      "en": "🔥 Vanilla / Leather",
      "sr": "🔥 Vanila / Koža"
    },
    "card": {
      "en": "Bergamot, aromatic lavender and warm vanilla over leather and woods.",
      "sr": "Bergamot, lavanda i topla vanila na podlozi kože i drveta."
    },
    "modal": {
      "en": "Fresh bergamot and cardamom lead into lavender and violet leaf. Vanilla, leather and woods create a warm, confident, masculine finish.",
      "sr": "Svež bergamot i kardamom otvaraju priču. Lavanda i list ljubičice donose eleganciju, dok vanila, koža i drvo daju topao, muževan završetak."
    },
    "scentType": {
      "en": "Ambery woody",
      "sr": "Drvenasto-ambarni"
    },
    "dominantNotes": {
      "sr": [
        "bergamot",
        "lavanda",
        "vanila",
        "koža"
      ],
      "en": [
        "bergamot",
        "lavender",
        "vanilla",
        "leather"
      ]
    },
    "tags": {
      "sr": [
        "Aromatičan",
        "Drvenast",
        "Elegantan"
      ],
      "en": [
        "Aromatic",
        "Woody",
        "Elegant"
      ]
    },
    "whyChoose": {
      "en": "For those who love refined masculine vanilla, aromatic freshness and warm leather.",
      "sr": "Za ljubitelje elegantne muške vanile, aromatične svežine i toplog kožnog akorda."
    }
  },

  "Bujairami Too Damn Good Extrait de Parfum": {
    "miniTag": {
      "en": "🍇 Fruity / Woody",
      "sr": "🍇 Voćni / Drvenasti"
    },
    "card": {
      "en": "Juicy blackcurrant, praline and violet over warm woods.",
      "sr": "Sočna ribizla, praline i ljubičica na toploj drvenastoj bazi."
    },
    "modal": {
      "en": "Blackcurrant, bergamot and lemon open bright and juicy. Praline and violet add soft sweetness, while musk, vetiver and cedar leave an elegant trail.",
      "sr": "Crna ribizla, bergamot i limun daju sočan početak. Praline i ljubičica unose meku slatkoću, dok mošus, vetiver i kedar ostavljaju elegantan trag."
    },
    "scentType": {
      "en": "Fruity woody",
      "sr": "Voćno-drvenasti"
    },
    "dominantNotes": {
      "sr": [
        "crna ribizla",
        "praline",
        "ljubičica",
        "vetiver"
      ],
      "en": [
        "blackcurrant",
        "praline",
        "violet",
        "vetiver"
      ]
    },
    "tags": {
      "sr": [
        "Voćni",
        "Puderast",
        "Drvenast"
      ],
      "en": [
        "Fruity",
        "Powdery",
        "Woody"
      ]
    },
    "whyChoose": {
      "en": "For lovers of juicy fruit, soft praline sweetness and a clean woody drydown.",
      "sr": "Za ljubitelje sočnog voća, nežne slatkoće pralina i čiste, drvenaste završnice."
    }
  },

  "Bujairami Hectic Extrait de Parfum": {
    "miniTag": {
      "en": "🍊 Citrus / Tea",
      "sr": "🍊 Citrusni / Čajni"
    },
    "card": {
      "en": "Bright citrus, ginger and black tea over a clean woody base.",
      "sr": "Svetli citrusi, đumbir i crni čaj na čistoj drvenastoj bazi."
    },
    "modal": {
      "en": "Citron, bergamot and orange open bright and fresh. Ginger, cinnamon and neroli add character, while black tea, ambroxan and woods leave a dry trail.",
      "sr": "Citron, bergamot i pomorandža otvaraju sveže i vedro. Đumbir, cimet i neroli daju karakter, dok crni čaj, ambroksan i drvo ostavljaju suv trag."
    },
    "scentType": {
      "en": "Citrus aromatic",
      "sr": "Citrusno-aromatični"
    },
    "dominantNotes": {
      "sr": [
        "citron",
        "đumbir",
        "crni čaj",
        "ambroksan"
      ],
      "en": [
        "citron",
        "ginger",
        "black tea",
        "ambroxan"
      ]
    },
    "tags": {
      "sr": [
        "Citrusni",
        "Začinski",
        "Čist"
      ],
      "en": [
        "Citrus",
        "Spicy",
        "Clean"
      ]
    },
    "whyChoose": {
      "en": "For lovers of bright citrus, ginger, black tea and refined woody freshness.",
      "sr": "Za ljubitelje živih citrusa, đumbira, crnog čaja i elegantne drvenaste svežine."
    }
  }
};

/* =========================================
   FALLBACK COPY
========================================= */

export const fallbackCopy = {
  miniTag: {
    sr: "💎 Luksuzan / Prepoznatljiv",
    en: "💎 Luxury / Signature",
  },
  card: {
    sr: "Premium miris sa karakterom i pažljivo biranim akordima.",
    en: "A premium fragrance with character and carefully chosen accords.",
  },
  modal: {
    sr: "Pažljivo odabran miris sa upečatljivim stilom, dominantnim akordima i premium PlayNice karakterom.",
    en: "A carefully selected fragrance with distinctive style, dominant accords and premium PlayNice character.",
  },
  scentType: {
    sr: "Prepoznatljiv miris",
    en: "Signature fragrance",
  },
  dominantNotes: {
    sr: ["premium akordi"],
    en: ["premium accords"],
  },
  tags: {
    sr: ["Prepoznatljiv"],
    en: ["Signature"],
  },
  whyChoose: {
    sr: "Odličan izbor za otkrivanje mirisa sa karakterom, jasnim identitetom i premium utiskom u formatu dekanta.",
    en: "A strong choice for discovering a fragrance with character, clear identity and a premium feel in decant format.",
  },
};